/**
 *
 * Records Page
 *
 */
import React, { useState, useEffect } from "react"
import Select from "react-select"
import Modal from "react-bootstrap/Modal"
import MetaTags from "react-meta-tags"
import { withRouter } from "react-router-dom"
import moment from "moment"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Table,
  Spinner,
  Input,
} from "reactstrap"
import { connect } from "react-redux"
import PropTypes from "prop-types"
//Import Breadcrumb
import { useSelector, useDispatch } from "react-redux"
import { isEmpty } from "lodash"
import Breadcrumbs from "../../components/Common/Breadcrumb"
//Import Styles
import "./styles.scss"
// import { CSVExport } from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import { ToastContainer } from "react-toastify"
// import SimpleReactValidator from "simple-react-validator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import * as employeeRecordAction from "../../store/eWVhckVtcGxveWVlUmVjb3Jk/actions"
import ButtonSpinner from "../../components/ButtonSpinner"
import api from "helpers/Api"

const YearWiseEmployeeRecord = (props) => {
  const title = "Year Wise Employee Record"
  const { dispatch, searchBarStyle } = props
  //component and validations

  const specificDispatch = useDispatch()
  // const simpleValidator = useRef(new SimpleReactValidator())
  // const [, forceUpdate] = useState()

  //Initial year and next year date format

  var date = new Date()
  var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
  var nextYear = new Date(date.getFullYear() + 1, date.getMonth(), 1)

  const startingDay = moment(firstDay).format("YYYY-MM")
  const nextYearList = moment(nextYear).format("YYYY-MM")

  const currentYearDetails = moment().format("YYYY")
  const currentYear = parseInt(currentYearDetails)
  console.log(currentYear, "currentYear")
  // let id = useParams()
  useEffect(() => {
    dispatch(employeeRecordAction.loadRecordsMetaData())
    dispatch(employeeRecordAction.loadEmployee())
    // dispatch(employeeAction.loadProcessStatus(mode))
    // dispatch(employeeRecordAction.loadEmployeeRecord())
    dispatch(
      employeeRecordAction.loadEmployeeRecord({
        year: currentYear,
        page: 1,
        limit: 50,
      })
    )
    setApplyFilter(false)
  }, [])

  const leaveUpdate = useSelector(
    (specificstate) => specificstate.yearEmployeeRecord
  )
  const {
    recordsMetaData = {},
    employee_list = [],
    employee_record = [],
  } = leaveUpdate

  const [employeeRecordData, setEmployeeRecordData] = useState({
    company: [],
    branch: [],
    department: [],
    employeeCode: "",
    fromDate: "",
    toDate: "",
    count: "",
    lossOfPay: [],
  })
  const handleChange = (e) => {
    setEmployeeRecordData({
      ...employeeRecordData,
      [e.target.name]: e.target.value,
    })
  }

  console.log(employeeRecordData.fromDate, "from date")

  //dropdown list
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [departmentlist, setDepartmentlist] = useState([])
  const [designation, setDesignation] = useState([])
  const [employeeCode, setEmployeeCode] = useState([])
  const [btnLoader, setBtnLoader] = useState(false)
  const [applyFilter, setApplyFilter] = useState(false)

  //Leave edit
  /// Count list start

  //Jan Month
  const [janLeaveCL, setJanLeaveCL] = useState(false)
  const [janLeaveCLDetails, setJanLeaveCLDetails] = useState("")
  const handleJanLeaveCL = () => setJanLeaveCL(false)

  const [janLeaveSL, setJanLeaveSL] = useState(false)
  const [janLeaveSLDetails, setJanLeaveSLDetails] = useState("")
  const handleJanLeaveSL = () => setJanLeaveSL(false)

  const [janLeaveGL, setJanLeaveGL] = useState(false)
  const [janLeaveGLDetails, setJanLeaveGLDetails] = useState("")
  const handleJanLeaveGL = () => setJanLeaveGL(false)

  const [permissionCount, setPermissionCount] = useState(false)
  const [permissionDetails, setPermissionDetails] = useState("")
  const handlePermissionCount = () => setPermissionCount(false)

  const [leaveAbsent, setLeaveAbsent] = useState(false)
  const [leaveAbsentDetails, setLeaveAbsentDetails] = useState("")
  const handleLeaveAbsent = () => setLeaveAbsent(false)

  const [delegationCount, setDelegationCount] = useState(false)
  const [delegationDetails, setDelegationDetails] = useState("")
  const handleDelegationAbsent = () => setDelegationCount(false)

  const [nightShift, setNightShift] = useState(false)
  const [nightShiftDetails, setNightShiftDetails] = useState("")

  const handleNightShift = () => setNightShift(false)

  const [wfh, setWfh] = useState(false)
  const [wfhDetails, setWfhDetails] = useState("")
  const handleWfh = () => setWfh(false)
  //Feb Leave
  const [febLeaveCL, setFebLeaveCL] = useState(false)
  const [febLeaveCLDetails, setFebLeaveCLDetails] = useState("")
  const handleFebLeaveCL = () => setFebLeaveCL(false)

  const [febLeaveSL, setFebLeaveSL] = useState(false)
  const [febLeaveSLDetails, setFebLeaveSLDetails] = useState("")
  const handleFebLeaveSL = () => setFebLeaveSL(false)

  const [febLeaveGL, setFebLeaveGL] = useState(false)
  const [febLeaveGLDetails, setFebLeaveGLDetails] = useState("")
  const handleFebLeaveGL = () => setFebLeaveGL(false)

  const [febPermissionCount, setFebPermissionCount] = useState(false)
  const [febPermissionDetails, setFebPermissionDetails] = useState("")
  const handleFebPermissionCount = () => setFebPermissionCount(false)

  const [febLeaveAbsent, setFebLeaveAbsent] = useState(false)
  const [febLeaveAbsentDetails, setFebLeaveAbsentDetails] = useState("")
  const handleFebLeaveAbsent = () => setFebLeaveAbsent(false)

  const [febDelegationCount, setFebDelegationCount] = useState(false)
  const [febDelegationDetails, setFebDelegationDetails] = useState("")
  const handleFebDelegationAbsent = () => setFebDelegationCount(false)

  const [febNightShift, setFebNightShift] = useState(false)
  const [febNightShiftDetails, setFebNightShiftDetails] = useState("")
  const handleFebNightShift = () => setFebNightShift(false)

  const [febWfh, setFebWfh] = useState(false)
  const [febWfhDetails, setFebWfhDetails] = useState("")
  const handleFebWfh = () => setFebWfh(false)
  //Mar Leave
  const [marLeaveCL, setMarLeaveCL] = useState(false)
  const [marLeaveCLDetails, setMarLeaveCLDetails] = useState("")
  const handleMarLeaveCL = () => setMarLeaveCL(false)

  const [marLeaveSL, setMarLeaveSL] = useState(false)
  const [marLeaveSLDetails, setMarLeaveSLDetails] = useState("")
  const handleMarLeaveSL = () => setMarLeaveSL(false)

  const [marLeaveGL, setMarLeaveGL] = useState(false)
  const [marLeaveGLDetails, setMarLeaveGLDetails] = useState("")
  const handleMarLeaveGL = () => setMarLeaveGL(false)

  const [marPermissionCount, setMarPermissionCount] = useState(false)
  const [marPermissionDetails, setMarPermissionDetails] = useState("")
  const handleMarPermissionCount = () => setMarPermissionCount(false)

  const [marLeaveAbsent, setMarLeaveAbsent] = useState(false)
  const [marLeaveAbsentDetails, setMarLeaveAbsentDetails] = useState("")
  const handleMarLeaveAbsent = () => setMarLeaveAbsent(false)

  const [marDelegationCount, setMarDelegationCount] = useState(false)
  const [marDelegationDetails, setMarDelegationDetails] = useState("")
  const handleMarDelegationAbsent = () => setMarDelegationCount(false)

  const [marNightShift, setMarNightShift] = useState(false)
  const [marNightShiftDetails, setMarNightShiftDetails] = useState("")
  const handleMarNightShift = () => setMarNightShift(false)

  const [marWfh, setMarWfh] = useState(false)
  const [marWfhDetails, setMarWfhDetails] = useState("")
  const handleMarWfh = () => setMarWfh(false)
  //Apr Leave
  const [aprLeaveCL, setAprLeaveCL] = useState(false)
  const [aprLeaveCLDetails, setAprLeaveCLDetails] = useState("")
  const handleAprLeaveCL = () => setAprLeaveCL(false)

  const [aprLeaveSL, setAprLeaveSL] = useState(false)
  const [aprLeaveSLDetails, setAprLeaveSLDetails] = useState("")
  const handleAprLeaveSL = () => setAprLeaveSL(false)

  const [aprLeaveGL, setAprLeaveGL] = useState(false)
  const [aprLeaveGLDetails, setAprLeaveGLDetails] = useState("")
  const handleAprLeaveGL = () => setAprLeaveGL(false)

  const [aprPermissionCount, setAprPermissionCount] = useState(false)
  const [aprPermissionDetails, setAprPermissionDetails] = useState("")
  const handleAprPermissionCount = () => setAprPermissionCount(false)

  const [aprLeaveAbsent, setAprLeaveAbsent] = useState(false)
  const [aprLeaveAbsentDetails, setAprLeaveAbsentDetails] = useState("")
  const handleAprLeaveAbsent = () => setAprLeaveAbsent(false)

  const [aprDelegationCount, setAprDelegationCount] = useState(false)
  const [aprDelegationDetails, setAprDelegationDetails] = useState("")
  const handleAprDelegation = () => setAprDelegationCount(false)

  const [aprNightShift, setAprNightShift] = useState(false)
  const [aprNightShiftDetails, setAprNightShiftDetails] = useState("")
  const handleAprNightShift = () => setAprNightShift(false)

  const [aprWfh, setAprWfh] = useState(false)
  const [aprWfhDetails, setAprWfhDetails] = useState("")
  const handleAprWfh = () => setAprWfh(false)
  //May Leave
  const [mayLeaveCL, setMayLeaveCL] = useState(false)
  const [mayLeaveCLDetails, setMayLeaveCLDetails] = useState("")
  const handleMayLeaveCL = () => setMayLeaveCL(false)

  const [mayLeaveSL, setMayLeaveSL] = useState(false)
  const [mayLeaveSLDetails, setMayLeaveSLDetails] = useState("")
  const handleMayLeaveSL = () => setMayLeaveSL(false)

  const [mayLeaveGL, setMayLeaveGL] = useState(false)
  const [mayLeaveGLDetails, setMayLeaveGLDetails] = useState("")
  const handleMayLeaveGL = () => setMayLeaveGL(false)

  const [mayPermissionCount, setMayPermissionCount] = useState(false)
  const [mayPermissionDetails, setMayPermissionDetails] = useState("")
  const handleMayPermissionCount = () => setMayPermissionCount(false)

  const [mayLeaveAbsent, setMayLeaveAbsent] = useState(false)
  const [mayLeaveAbsentDetails, setMayLeaveAbsentDetails] = useState("")
  const handleMayLeaveAbsent = () => setMayLeaveAbsent(false)

  const [mayDelegationCount, setMayDelegationCount] = useState(false)
  const [mayDelegationDetails, setMayDelegationDetails] = useState("")
  const handleMayDelegation = () => setMayDelegationCount(false)

  const [mayNightShift, setMayNightShift] = useState(false)
  const [mayNightShiftDetails, setMayNightShiftDetails] = useState("")
  const handleMayNightShift = () => setMayNightShift(false)

  const [mayWfh, setMayWfh] = useState(false)
  const [mayWfhDetails, setMayWfhDetails] = useState("")
  const handleMayWfh = () => setMayWfh(false)
  //June Leave
  const [juneLeaveCL, setJuneLeaveCL] = useState(false)
  const [juneLeaveCLDetails, setJuneLeaveCLDetails] = useState("")
  const handleJuneLeaveCL = () => setJuneLeaveCL(false)

  const [juneLeaveSL, setJuneLeaveSL] = useState(false)
  const [juneLeaveSLDetails, setJuneLeaveSLDetails] = useState("")
  const handleJuneLeaveSL = () => setJuneLeaveSL(false)

  const [juneLeaveGL, setJuneLeaveGL] = useState(false)
  const [juneLeaveGLDetails, setJuneLeaveGLDetails] = useState("")
  const handleJuneLeaveGL = () => setJuneLeaveGL(false)

  const [junePermissionCount, setJunePermissionCount] = useState(false)
  const [junePermissionDetails, setJunePermissionDetails] = useState("")
  const handleJunePermissionCount = () => setJunePermissionCount(false)

  const [juneDelegationCount, setJuneDelegationCount] = useState(false)
  const [juneDelegationDetails, setJuneDelegationDetails] = useState("")
  const handleJuneDelegation = () => setJuneDelegationCount(false)

  const [juneNightShift, setJuneNightShift] = useState(false)
  const [juneNightShiftDetails, setJuneNightShiftDetails] = useState("")
  const handleJuneNightShift = () => setJuneNightShift(false)

  const [juneLeaveAbsent, setJuneLeaveAbsent] = useState(false)
  const [juneLeaveAbsentDetails, setJuneLeaveAbsentDetails] = useState("")
  const handleJuneLeaveAbsent = () => setJuneLeaveAbsent(false)

  const [juneWfh, setJuneWfh] = useState(false)
  const [juneWfhDetails, setJuneWfhDetails] = useState("")
  const handleJuneWfh = () => setJuneWfh(false)
  //July Leave
  const [julyLeaveCL, setJulyLeaveCL] = useState(false)
  const [julyLeaveCLDetails, setJulyLeaveCLDetails] = useState("")
  const handleJulyLeaveCL = () => setJulyLeaveCL(false)

  const [julyLeaveSL, setJulyLeaveSL] = useState(false)
  const [julyLeaveSLDetails, setJulyLeaveSLDetails] = useState("")
  const handleJulyLeaveSL = () => setJulyLeaveSL(false)

  const [julyLeaveGL, setJulyLeaveGL] = useState(false)
  const [julyLeaveGLDetails, setJulyLeaveGLDetails] = useState("")
  const handleJulyLeaveGL = () => setJulyLeaveGL(false)

  const [julyPermissionCount, setJulyPermissionCount] = useState(false)
  const [julyPermissionDetails, setJulyPermissionDetails] = useState("")
  const handleJulyPermissionCount = () => setJulyPermissionCount(false)

  const [julyLeaveAbsent, setJulyLeaveAbsent] = useState(false)
  const [julyLeaveAbsentDetails, setJulyLeaveAbsentDetails] = useState("")
  const handleJulyLeaveAbsent = () => setJulyLeaveAbsent(false)

  const [julyDelegationCount, setJulyDelegationCount] = useState(false)
  const [julyDelegationDetails, setJulyDelegationDetails] = useState("")
  const handleJulyDelegation = () => setJulyDelegationCount(false)

  const [julyNightShift, setJulyNightShift] = useState(false)
  const [julyNightShiftDetails, setJulyNightShiftDetails] = useState("")
  const handleJulyNightShift = () => setJulyNightShift(false)

  const [julyWfh, setJulyWfh] = useState(false)
  const [julyWfhDetails, setJulyWfhDetails] = useState("")
  const handleJulyWfh = () => setJulyWfh(false)
  //Aug Leave
  const [augLeaveCL, setAugLeaveCL] = useState(false)
  const [augLeaveCLDetails, setAugLeaveCLDetails] = useState("")
  const handleAugLeaveCL = () => setAugLeaveCL(false)

  const [augLeaveSL, setAugLeaveSL] = useState(false)
  const [augLeaveSLDetails, setAugLeaveSLDetails] = useState("")
  const handleAugLeaveSL = () => setAugLeaveSL(false)

  const [augLeaveGL, setAugLeaveGL] = useState(false)
  const [augLeaveGLDetails, setAugLeaveGLDetails] = useState("")
  const handleAugLeaveGL = () => setAugLeaveGL(false)

  const [augPermission, setAugPermission] = useState(false)
  const [augPermissionDetails, setAugPermissionDetails] = useState("")
  const handleAugPermission = () => setAugPermission(false)

  const [augLeaveAbsent, setAugLeaveAbsent] = useState(false)
  const [augLeaveAbsentDetails, setAugLeaveAbsentDetails] = useState("")
  const handleAugLeaveAbsent = () => setAugLeaveAbsent(false)

  const [augDelegation, setAugDelegation] = useState(false)
  const [augDelegationDetails, setAugDelegationDetails] = useState("")
  const handleAugDelegation = () => setAugDelegation(false)

  const [augNightShift, setAugNightShift] = useState(false)
  const [augNightShiftDetails, setAugNightShiftDetails] = useState("")
  const handleAugNightShift = () => setAugNightShift(false)

  const [augWfh, setAugWfh] = useState(false)
  const [augWfhDetails, setAugWfhDetails] = useState("")
  const handleAugWfh = () => setAugWfh(false)
  //Sep Leave
  const [sepLeaveCL, setSepLeaveCL] = useState(false)
  const [sepLeaveCLDetails, setSepLeaveCLDetails] = useState("")
  const handleSepLeaveCL = () => setSepLeaveCL(false)

  const [sepLeaveSL, setSepLeaveSL] = useState(false)
  const [sepLeaveSLDetails, setSepLeaveSLDetails] = useState("")
  const handleSepLeaveSL = () => setSepLeaveSL(false)

  const [sepLeaveGL, setSepLeaveGL] = useState(false)
  const [sepLeaveGLDetails, setSepLeaveGLDetails] = useState("")
  const handleSepLeaveGL = () => setSepLeaveGL(false)

  const [sepPermission, setSepPermission] = useState(false)
  const [sepPermissionDetails, setSepPermissionDetails] = useState("")
  const handleSepPermission = () => setSepPermission(false)

  const [sepLeaveAbsent, setSepLeaveAbsent] = useState(false)
  const [sepLeaveAbsentDetails, setSepLeaveAbsentDetails] = useState("")
  const handleSepLeaveAbsent = () => setSepLeaveAbsent(false)

  const [sepDelegation, setSepDelegation] = useState(false)
  const [sepDelegationDetails, setSepDelegationDetails] = useState("")
  const handleSepDelegation = () => setSepDelegation(false)

  const [sepNightShift, setSepNightShift] = useState(false)
  const [sepNightShiftDetails, setSepNightShiftDetails] = useState("")
  const handleSepNightShift = () => setSepNightShift(false)

  const [sepWfh, setSepWfh] = useState(false)
  const [sepWfhDetails, setSepWfhDetails] = useState("")
  const handleSepWfh = () => setSepWfh(false)

  //Oct Leave
  const [octLeaveCL, setOctLeaveCL] = useState(false)
  const [octLeaveCLDetails, setOctLeaveCLDetails] = useState("")
  const handleOctLeaveCL = () => setOctLeaveCL(false)

  const [octLeaveSL, setOctLeaveSL] = useState(false)
  const [octLeaveSLDetails, setOctLeaveSLDetails] = useState("")
  const handleOctLeaveSL = () => setOctLeaveSL(false)

  const [octLeaveGL, setOctLeaveGL] = useState(false)
  const [octLeaveGLDetails, setOctLeaveGLDetails] = useState("")
  const handleOctLeaveGL = () => setOctLeaveGL(false)

  const [octPermission, setOctPermission] = useState(false)
  const [octPermissionDetails, setOctPermissionDetails] = useState("")
  const handleOctPermission = () => setOctPermission(false)

  const [octLeaveAbsent, setOctLeaveAbsent] = useState(false)
  const [octLeaveAbsentDetails, setOctLeaveAbsentDetails] = useState("")
  const handleOctLeaveAbsent = () => setOctLeaveAbsent(false)

  const [octDelegation, setOctDelegation] = useState(false)
  const [octDelegationDetails, setOctDelegationDetails] = useState("")
  const handleOctDelegation = () => setOctDelegation(false)

  const [octNightShift, setOctNightShift] = useState(false)
  const [octNightShiftDetails, setOctNightShiftDetails] = useState("")
  const handleOctNightShift = () => setOctNightShift(false)

  const [octWfh, setOctWfh] = useState(false)
  const [octWfhDetails, setOctWfhDetails] = useState("")
  const handleOctWfh = () => setOctWfh(false)

  //Nov Leave
  const [novLeaveCL, setNovLeaveCL] = useState(false)
  const [novLeaveCLDetails, setNovLeaveCLDetails] = useState("")
  const handleNovLeaveCL = () => setNovLeaveCL(false)

  const [novLeaveSL, setNovLeaveSL] = useState(false)
  const [novLeaveSLDetails, setNovLeaveSLDetails] = useState("")
  const handleNovLeaveSL = () => setNovLeaveSL(false)

  const [novLeaveGL, setNovLeaveGL] = useState(false)
  const [novLeaveGLDetails, setNovLeaveGLDetails] = useState("")
  const handleNovLeaveGL = () => setNovLeaveGL(false)

  const [novPermission, setNovPermission] = useState(false)
  const [novPermissionDetails, setNovPermissionDetails] = useState("")
  const handleNovPermission = () => setNovPermission(false)

  const [novLeaveAbsent, setNovLeaveAbsent] = useState(false)
  const [novLeaveAbsentDetails, setNovLeaveAbsentDetails] = useState("")
  const handleNovLeaveAbsent = () => setNovLeaveAbsent(false)

  const [novDelegation, setNovDelegation] = useState(false)
  const [novDelegationDetails, setNovDelegationDetails] = useState("")
  const handleNovDelegation = () => setNovDelegation(false)

  const [novNightShift, setNovNightShift] = useState(false)
  const [novNightShiftDetails, setNovNightShiftDetails] = useState("")
  const handleNovNightShift = () => setNovNightShift(false)

  const [novWfh, setNovWfh] = useState(false)
  const [novWfhDetails, setNovWfhDetails] = useState("")
  const handleNovWfh = () => setNovWfh(false)
  //Dec Leave
  const [decLeaveCL, setDecLeaveCL] = useState(false)
  const [decLeaveCLDetails, setDecLeaveCLDetails] = useState("")
  const handleDecLeaveCL = () => setDecLeaveCL(false)

  const [decLeaveSL, setDecLeaveSL] = useState(false)
  const [decLeaveSLDetails, setDecLeaveSLDetails] = useState("")
  const handleDecLeaveSL = () => setDecLeaveSL(false)

  const [decLeaveGL, setDecLeaveGL] = useState(false)
  const [decLeaveGLDetails, setDecLeaveGLDetails] = useState("")
  const handleDecLeaveGL = () => setDecLeaveGL(false)

  const [decPermission, setDecPermission] = useState(false)
  const [decPermissionDetails, setDecPermissionDetails] = useState("")
  const handleDecPermission = () => setDecPermission(false)

  const [decLeaveAbsent, setDecLeaveAbsent] = useState(false)
  const [decLeaveAbsentDetails, setDecLeaveAbsentDetails] = useState("")
  const handleDecLeaveAbsent = () => setDecLeaveAbsent(false)

  const [decDelegation, setDecDelegation] = useState(false)
  const [decDelegationDetails, setDecDelegationDetails] = useState("")
  const handleDecDelegation = () => setDecDelegation(false)

  const [decNightShift, setDecNightShift] = useState(false)
  const [decNightShiftDetails, setDecNightShiftDetails] = useState("")
  const handleDecNightShift = () => setDecNightShift(false)

  const [decWfh, setDecWfh] = useState(false)
  const [decWfhDetails, setDecWfhDetails] = useState("")
  const handleDecWfh = () => setDecWfh(false)
  //state section end

  //Update LPND status
  const branchOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.branchOptions.filter(
      (branch) =>
        branch.companyId ===
        companies.map((company) => company.value).toString()
    )

  const handleCompaniesChange = (e) => {
    setCompanies(e)
    setBranches([])
    setDepartmentlist([])
    setDesignation([])
  }
  const employeeList =
    !isEmpty(employee_list) &&
    employee_list.map((employee) => {
      return {
        _id: employee._id,
        empCode: employee.empCode,
        name: employee.name,
        companyId: employee.companyId,
        companyName: employee.companyName,
        branchName: employee.branchName,
        branchId: employee.branchId,
        departmentName: employee.departmentName,
        departmentId: employee.departmentId,
        designationName: employee.designationName,
        designationId: employee.designationId,
        roleId: employee.roleId,
      }
    })

  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        const labelEmployee = element.empCode.concat(" - ", element.name)
        let obj = {}
        obj.value = element._id
        obj.label = labelEmployee
        obj.empCode = element.empCode
        obj.name = element.name
        obj.companyId = element.companyId
        obj.companyName = element.companyName
        obj.branchId = element.branchId
        obj.branchName = element.branchName
        obj.departmentId = element.departmentId
        obj.departmentName = element.departmentName
        obj.designationId = element.designationId
        obj.designationName = element.designationName
        obj.roleId = element.roleId
        options.push(obj)
      })
    return options
  }

  const employeeOptions = createOptions(employeeList)

  const fuseOptions = {
    keys: ["empCode", "label"],
  }
  const company =
    !isEmpty(companies) && companies.map((company) => company.value)
  const branch = !isEmpty(branches) && branches.map((branch) => branch.value)
  //submit values
  // const [countFilterData, setCountFilterData] = useState(false)

  // Count filter

  // const d1 = new Date(employeeRecordData.fromDate)
  // const d2 = new Date(employeeRecordData.toDate)

  // var diff = d2.getTime() - d1.getTime()

  // const counterDate = diff / (1000 * 60 * 60 * 24) + 1

  //filter

  const [pageCount, setPageCount] = useState("")
  const [btnLoading, setBtnLoading] = useState(false)
  const [pageChange, setPageChange] = useState(false)

  //Aplly filter section
  const handleApply = () => {
    var searchCompany = company && company ? company : ""
    var searchBranch = branch && branch ? branch : ""
    var searchDepartment =
      departmentlist && departmentlist.value ? [departmentlist.value] : ""
    var searchDesignation =
      designation && designation.value ? [designation.value] : ""

    var searchEmpCode =
      employeeCode && employeeCode.empCode ? employeeCode.empCode : ""
    var searchEmpId =
      employeeCode && employeeCode.value ? employeeCode.value : ""

    var searchFromDateDetails =
      employeeRecordData && employeeRecordData.fromDate
        ? moment(employeeRecordData.fromDate).format("YYYY")
        : ""
    var searchFromDate = parseInt(searchFromDateDetails)
    // var searchToDate =
    //   employeeRecordData && employeeRecordData.toDate
    //     ? employeeRecordData.toDate
    //     : ""

    var searchvalue = {}
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = 50
    // searchvalue.year = currentYear
    if (searchCompany) {
      searchvalue.company = searchCompany
    }
    if (searchBranch) {
      searchvalue.branch = searchBranch
    }
    if (searchDepartment) {
      searchvalue.department = searchDepartment
    }
    if (searchDesignation) {
      searchvalue.designation = searchDesignation
    }
    if (searchEmpCode) {
      searchvalue.empCode = searchEmpCode
    }
    if (searchEmpId) {
      searchvalue.empId = searchEmpId
    }
    if (searchFromDate) {
      searchvalue.year = searchFromDate
    }
    // if (searchToDate) {
    //   searchvalue.endDate = searchToDate
    // }
    // if (searchStatus) {
    //   searchvalue.leaveStatus = searchStatus
    // }

    specificDispatch(employeeRecordAction.loadEmployeeRecord(searchvalue))
    setBtnLoader(true)
    setBtnLoading(true)
    setApplyFilter(true)
    setTimeout(() => {
      setBtnLoader(false)
      setBtnLoading(false)
    }, 2000)
  }

  // console.log(leaveStatus, "Leave Status")
  //Data table
  let slNo = 0
  const employeeRecordTable = !isEmpty(employee_record)
    ? employee_record.data.map((employeeRecord, index) => {
        slNo = slNo + 1

        var str = !isEmpty(employeeRecord.attachment)
          ? employeeRecord.attachment
          : []
        const fileUrl = isEmpty(str) ? "" : str.substring(str.indexOf("/"))
        const attachments = isEmpty(fileUrl)
          ? ""
          : "https://api.alphaone.app/uploads/" + fileUrl
        console.log(attachments, "attachment with alpha url")
        var fromDateTime = !isEmpty(employeeRecord.fromDate)
          ? moment(employeeRecord.fromDate)
              .subtract(5, "hours")
              .subtract(30, "minutes")
              .format("DD-MM-YYYY")
          : []

        var toDateTime = !isEmpty(employeeRecord.toDate)
          ? moment(employeeRecord.toDate)
              .subtract(5, "hours")
              .subtract(30, "minutes")
              .format("DD-MM-YYYY")
          : []

        const janLeaveDetails =
          !isEmpty(employeeRecord) && employeeRecord.leaveDetails
            ? employeeRecord.leaveDetails.find(
                (data) => data.month == "January"
              )
            : []
        const febLeaveDetails =
          !isEmpty(employeeRecord) && employeeRecord.leaveDetails
            ? employeeRecord.leaveDetails.find(
                (data) => data.month == "February"
              )
            : []
        const marLeaveDetails =
          !isEmpty(employeeRecord) && employeeRecord.leaveDetails
            ? employeeRecord.leaveDetails.find((data) => data.month == "March")
            : []
        const aprLeaveDetails =
          !isEmpty(employeeRecord) && employeeRecord.leaveDetails
            ? employeeRecord.leaveDetails.find((data) => data.month == "April")
            : []
        const mayLeaveDetails =
          !isEmpty(employeeRecord) && employeeRecord.leaveDetails
            ? employeeRecord.leaveDetails.find((data) => data.month == "May")
            : []
        const juneLeaveDetails =
          !isEmpty(employeeRecord) && employeeRecord.leaveDetails
            ? employeeRecord.leaveDetails.find((data) => data.month == "June")
            : []
        const julyLeaveDetails =
          !isEmpty(employeeRecord) && employeeRecord.leaveDetails
            ? employeeRecord.leaveDetails.find((data) => data.month == "July")
            : []
        const augustLeaveDetails =
          !isEmpty(employeeRecord) && employeeRecord.leaveDetails
            ? employeeRecord.leaveDetails.find((data) => data.month == "August")
            : []
        const sepLeaveDetails =
          !isEmpty(employeeRecord) && employeeRecord.leaveDetails
            ? employeeRecord.leaveDetails.find(
                (data) => data.month == "September"
              )
            : []
        const octLeaveDetails =
          !isEmpty(employeeRecord) && employeeRecord.leaveDetails
            ? employeeRecord.leaveDetails.find(
                (data) => data.month == "October"
              )
            : []
        const novLeaveDetails =
          !isEmpty(employeeRecord) && employeeRecord.leaveDetails
            ? employeeRecord.leaveDetails.find(
                (data) => data.month == "November"
              )
            : []
        const decLeaveDetails =
          !isEmpty(employeeRecord) && employeeRecord.leaveDetails
            ? employeeRecord.leaveDetails.find(
                (data) => data.month == "December"
              )
            : []
        const totalLeaveDetails =
          !isEmpty(employeeRecord) && employeeRecord.leaveDetails
            ? employeeRecord.leaveDetails.find(
                (data) => data.type == "total-values"
              )
            : []

        const totalLeaveCount = totalLeaveDetails.totalCl

        // console.log(decimalCount(1.123456789)) // 9
        // console.log(decimalCount(123456789))
        console.log(totalLeaveCount, "totalLeaveCount")
        console.log(janLeaveDetails, "janLeaveDetails")
        console.log(totalLeaveDetails, "totalLeaveDetails")
        return {
          _id: employeeRecord._id,
          sNo: slNo,
          branchId: employeeRecord.branchId,
          branchName: employeeRecord.branchName,
          companyId: employeeRecord.companyId,
          companyName: employeeRecord.companyName,
          departmentId: employeeRecord.departmentId,
          departmentName: employeeRecord.departmentName,
          designationId: employeeRecord.designationId,
          designationName: employeeRecord.designationName,
          employeeCode: employeeRecord.employeeCode,
          employeeName: employeeRecord.employeeName,
          workingDays: employeeRecord.workingDays,
          fromDate: fromDateTime,
          janLeave: (
            <table style={{ marginBottom: "-12px", marginTop: "-12px" }}>
              <thead>
                <th
                  style={{
                    padding: "22px 13px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setJanLeaveCLDetails(janLeaveDetails.clDetail)
                    setJanLeaveCL(true)
                  }}
                >
                  {!isEmpty(janLeaveDetails) ? janLeaveDetails.cl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 11.5px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setJanLeaveSLDetails(janLeaveDetails.slDetail)
                    setJanLeaveSL(true)
                  }}
                >
                  {!isEmpty(janLeaveDetails) ? janLeaveDetails.sl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 13px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setJanLeaveGLDetails(janLeaveDetails.glDetail)
                    setJanLeaveGL(true)
                  }}
                >
                  {!isEmpty(janLeaveDetails) ? janLeaveDetails.gl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 16.5px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setPermissionDetails(janLeaveDetails.permissionDetail)
                    setPermissionCount(true)
                  }}
                >
                  {!isEmpty(janLeaveDetails) ? janLeaveDetails.permission : 0}
                </th>
                <th
                  style={{
                    padding: "22px 19px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setDelegationDetails(janLeaveDetails.delegationDetail)
                    setDelegationCount(true)
                  }}
                >
                  {!isEmpty(janLeaveDetails) ? janLeaveDetails.delegation : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15.5px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setNightShiftDetails(janLeaveDetails.nightShiftDetail)
                    setNightShift(true)
                  }}
                >
                  {!isEmpty(janLeaveDetails) ? janLeaveDetails.nightShift : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15.5px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setWfhDetails(janLeaveDetails.nightShiftDetail)
                    setWfh(true)
                  }}
                >
                  {!isEmpty(janLeaveDetails.wfh) ? janLeaveDetails.wfh : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                    cursor: "pointer",
                    borderRight: "1px solid transparent",
                  }}
                  onClick={() => {
                    setLeaveAbsentDetails(janLeaveDetails.absentDetail)
                    setLeaveAbsent(true)
                  }}
                >
                  {!isEmpty(janLeaveDetails) ? janLeaveDetails.absent : 0}
                </th>
              </thead>
            </table>
          ),
          febLeave: (
            <table style={{ marginBottom: "-12px", marginTop: "-12px" }}>
              <thead>
                <th
                  style={{
                    padding: "22px 13px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setFebLeaveCLDetails(febLeaveDetails.clDetail)
                    setFebLeaveCL(true)
                  }}
                >
                  {!isEmpty(febLeaveDetails) ? febLeaveDetails.cl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 11.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setFebLeaveSLDetails(febLeaveDetails.slDetail)
                    setFebLeaveSL(true)
                  }}
                >
                  {!isEmpty(febLeaveDetails) ? febLeaveDetails.sl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 13px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setFebLeaveGLDetails(febLeaveDetails.glDetail)
                    setFebLeaveGL(true)
                  }}
                >
                  {!isEmpty(febLeaveDetails) ? febLeaveDetails.gl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 16.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setFebPermissionDetails(febLeaveDetails.permissionDetail)
                    setFebPermissionCount(true)
                  }}
                >
                  {!isEmpty(febLeaveDetails) ? febLeaveDetails.permission : 0}
                </th>
                <th
                  style={{
                    padding: "22px 19px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setFebDelegationDetails(febLeaveDetails.delegationDetail)
                    setFebDelegationCount(true)
                  }}
                >
                  {!isEmpty(febLeaveDetails) ? febLeaveDetails.delegation : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setFebNightShiftDetails(febLeaveDetails.nightShiftDetail)
                    setFebNightShift(true)
                  }}
                >
                  {!isEmpty(febLeaveDetails) ? febLeaveDetails.nightShift : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15.5px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setFebWfhDetails(febLeaveDetails.wfhDetail)
                    setFebWfh(true)
                  }}
                >
                  {!isEmpty(febLeaveDetails.wfh) ? febLeaveDetails.wfh : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                    borderRight: "1px solid transparent",
                  }}
                  onClick={() => {
                    setFebLeaveAbsentDetails(febLeaveDetails.absentDetail)
                    setFebLeaveAbsent(true)
                  }}
                >
                  {!isEmpty(febLeaveDetails) ? febLeaveDetails.absent : 0}
                </th>
              </thead>
            </table>
          ),
          marLeave: (
            <table style={{ marginBottom: "-12px", marginTop: "-12px" }}>
              <thead>
                <th
                  style={{
                    padding: "22px 13px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setMarLeaveCLDetails(marLeaveDetails.clDetail)
                    setMarLeaveCL(true)
                  }}
                >
                  {!isEmpty(marLeaveDetails) ? marLeaveDetails.cl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 11.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setMarLeaveSLDetails(marLeaveDetails.slDetail)
                    setMarLeaveSL(true)
                  }}
                >
                  {!isEmpty(marLeaveDetails) ? marLeaveDetails.sl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 13px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setMarLeaveGLDetails(marLeaveDetails.glDetail)
                    setMarLeaveGL(true)
                  }}
                >
                  {!isEmpty(marLeaveDetails) ? marLeaveDetails.gl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 16.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setMarPermissionDetails(marLeaveDetails.permissionDetail)
                    setMarPermissionCount(true)
                  }}
                >
                  {!isEmpty(marLeaveDetails) ? marLeaveDetails.permission : 0}
                </th>
                <th
                  style={{
                    padding: "22px 19px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setMarLeaveAbsentDetails(marLeaveDetails.delegationDetail)
                    setMarLeaveAbsent(true)
                  }}
                >
                  {!isEmpty(marLeaveDetails) ? marLeaveDetails.delegation : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setMarDelegationDetails(marLeaveDetails.nightShiftDetail)
                    setMarDelegationCount(true)
                  }}
                >
                  {!isEmpty(marLeaveDetails) ? marLeaveDetails.nightShift : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15.5px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setMarWfhDetails(marLeaveDetails.wfhDetail)
                    setMarWfh(true)
                  }}
                >
                  {!isEmpty(marLeaveDetails.wfh) ? marLeaveDetails.wfh : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                    borderRight: "1px solid transparent",
                  }}
                  onClick={() => {
                    setMarNightShiftDetails(marLeaveDetails.absentDetail)
                    setMarNightShift(true)
                  }}
                >
                  {!isEmpty(marLeaveDetails) ? marLeaveDetails.absent : 0}
                </th>
              </thead>
            </table>
          ),
          aprLeave: (
            <table style={{ marginBottom: "-12px", marginTop: "-12px" }}>
              <thead>
                <th
                  style={{
                    padding: "22px 13px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setAprLeaveCLDetails(aprLeaveDetails.clDetail)
                    setAprLeaveCL(true)
                  }}
                >
                  {!isEmpty(aprLeaveDetails) ? aprLeaveDetails.cl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 11.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setAprLeaveSLDetails(aprLeaveDetails.slDetail)
                    setAprLeaveSL(true)
                  }}
                >
                  {!isEmpty(aprLeaveDetails) ? aprLeaveDetails.sl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 13px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setAprLeaveGLDetails(aprLeaveDetails.glDetail)
                    setAprLeaveGL(true)
                  }}
                >
                  {!isEmpty(aprLeaveDetails) ? aprLeaveDetails.gl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 16.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setAprPermissionDetails(aprLeaveDetails.permissionDetail)
                    setAprPermissionCount(true)
                  }}
                >
                  {!isEmpty(aprLeaveDetails) ? aprLeaveDetails.permission : 0}
                </th>
                <th
                  style={{
                    padding: "22px 19px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setAprLeaveAbsentDetails(aprLeaveDetails.delegationDetail)
                    setAprLeaveAbsent(true)
                  }}
                >
                  {!isEmpty(aprLeaveDetails) ? aprLeaveDetails.delegation : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setAprDelegationDetails(aprLeaveDetails.nightShiftDetail)
                    setAprDelegationCount(true)
                  }}
                >
                  {!isEmpty(aprLeaveDetails) ? aprLeaveDetails.nightShift : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15.5px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setAprWfhDetails(aprLeaveDetails.wfhDetail)
                    setAprWfh(true)
                  }}
                >
                  {!isEmpty(aprLeaveDetails.wfh) ? aprLeaveDetails.wfh : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                    borderRight: "1px solid transparent",
                  }}
                  onClick={() => {
                    setAprNightShiftDetails(aprLeaveDetails.absentDetail)
                    setAprNightShift(true)
                  }}
                >
                  {!isEmpty(aprLeaveDetails) ? aprLeaveDetails.absent : 0}
                </th>
              </thead>
            </table>
          ),
          mayLeave: (
            <table style={{ marginBottom: "-12px", marginTop: "-12px" }}>
              <thead>
                <th
                  style={{
                    padding: "22px 13px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setMayLeaveCLDetails(mayLeaveDetails.clDetail)
                    setMayLeaveCL(true)
                  }}
                >
                  {!isEmpty(mayLeaveDetails) ? mayLeaveDetails.cl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 11.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setMayLeaveSLDetails(mayLeaveDetails.slDetail)
                    setMayLeaveSL(true)
                  }}
                >
                  {!isEmpty(mayLeaveDetails) ? mayLeaveDetails.sl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 13px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setMayLeaveGLDetails(mayLeaveDetails.glDetail)
                    setMayLeaveGL(true)
                  }}
                >
                  {!isEmpty(mayLeaveDetails) ? mayLeaveDetails.gl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 16.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setMayPermissionDetails(mayLeaveDetails.permissionDetail)
                    setMayPermissionCount(true)
                  }}
                >
                  {!isEmpty(mayLeaveDetails) ? mayLeaveDetails.permission : 0}
                </th>
                <th
                  style={{
                    padding: "22px 19px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setMayDelegationDetails(mayLeaveDetails.delegationDetail)
                    setMayDelegationCount(true)
                  }}
                >
                  {!isEmpty(mayLeaveDetails) ? mayLeaveDetails.delegation : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setMayNightShiftDetails(mayLeaveDetails.nightShiftDetail)
                    setMayNightShift(true)
                  }}
                >
                  {!isEmpty(mayLeaveDetails) ? mayLeaveDetails.nightShift : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15.5px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setMayWfhDetails(mayLeaveDetails.wfhDetail)
                    setMayWfh(true)
                  }}
                >
                  {!isEmpty(mayLeaveDetails.wfh) ? mayLeaveDetails.wfh : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                    borderRight: "1px solid transparent",
                  }}
                  onClick={() => {
                    setMayLeaveAbsentDetails(mayLeaveDetails.absentDetail)
                    setMayLeaveAbsent(true)
                  }}
                >
                  {!isEmpty(mayLeaveDetails) ? mayLeaveDetails.absent : 0}
                </th>
              </thead>
            </table>
          ),
          juneLeave: (
            <table style={{ marginBottom: "-12px", marginTop: "-12px" }}>
              <thead>
                <th
                  style={{
                    padding: "22px 13px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setJuneLeaveCLDetails(juneLeaveDetails.clDetail)
                    setJuneLeaveCL(true)
                  }}
                >
                  {!isEmpty(juneLeaveDetails) ? juneLeaveDetails.cl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 11.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setJuneLeaveSLDetails(juneLeaveDetails.slDetail)
                    setJuneLeaveSL(true)
                  }}
                >
                  {!isEmpty(juneLeaveDetails) ? juneLeaveDetails.sl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 13px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setJuneLeaveGLDetails(juneLeaveDetails.glDetail)
                    setJuneLeaveGL(true)
                  }}
                >
                  {!isEmpty(juneLeaveDetails) ? juneLeaveDetails.gl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 16.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setJunePermissionDetails(juneLeaveDetails.permissionDetail)
                    setJunePermissionCount(true)
                  }}
                >
                  {!isEmpty(juneLeaveDetails) ? juneLeaveDetails.permission : 0}
                </th>
                <th
                  style={{
                    padding: "22px 19px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setJuneDelegationDetails(juneLeaveDetails.delegationDetail)
                    setJuneDelegationCount(true)
                  }}
                >
                  {!isEmpty(juneLeaveDetails) ? juneLeaveDetails.delegation : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setJuneNightShiftDetails(juneLeaveDetails.nightShiftDetail)
                    setJuneNightShift(true)
                  }}
                >
                  {!isEmpty(juneLeaveDetails) ? juneLeaveDetails.nightShift : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15.5px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setJuneWfhDetails(juneLeaveDetails.wfhDetail)
                    setJuneWfh(true)
                  }}
                >
                  {!isEmpty(juneLeaveDetails.wfh) ? juneLeaveDetails.wfh : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                    borderRight: "1px solid transparent",
                  }}
                  onClick={() => {
                    setJuneLeaveAbsentDetails(juneLeaveDetails.absentDetail)
                    setJuneLeaveAbsent(true)
                  }}
                >
                  {!isEmpty(juneLeaveDetails) ? juneLeaveDetails.absent : 0}
                </th>
              </thead>
            </table>
          ),
          julyLeave: (
            <table style={{ marginBottom: "-12px", marginTop: "-12px" }}>
              <thead>
                <th
                  style={{
                    padding: "22px 13px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setJulyLeaveCLDetails(julyLeaveDetails.clDetail)
                    setJulyLeaveCL(true)
                  }}
                >
                  {!isEmpty(julyLeaveDetails) ? julyLeaveDetails.cl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 11.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setJulyLeaveSLDetails(julyLeaveDetails.slDetail)
                    setJulyLeaveSL(true)
                  }}
                >
                  {!isEmpty(julyLeaveDetails) ? julyLeaveDetails.sl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 13px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setJulyLeaveGLDetails(julyLeaveDetails.glDetail)
                    setJulyLeaveGL(true)
                  }}
                >
                  {!isEmpty(julyLeaveDetails) ? julyLeaveDetails.gl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 16.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setJulyPermissionDetails(julyLeaveDetails.permissionDetail)
                    setJulyPermissionCount(true)
                  }}
                >
                  {!isEmpty(julyLeaveDetails) ? julyLeaveDetails.permission : 0}
                </th>
                <th
                  style={{
                    padding: "22px 19px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setJulyDelegationDetails(julyLeaveDetails.delegationDetail)
                    setJulyDelegationCount(true)
                  }}
                >
                  {!isEmpty(julyLeaveDetails) ? julyLeaveDetails.delegation : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setJulyNightShiftDetails(julyLeaveDetails.nightShiftDetail)
                    setJulyNightShift(true)
                  }}
                >
                  {!isEmpty(julyLeaveDetails) ? julyLeaveDetails.nightShift : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15.5px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setJulyWfhDetails(julyLeaveDetails.wfhDetail)
                    setJulyWfh(true)
                  }}
                >
                  {!isEmpty(julyLeaveDetails.wfh) ? julyLeaveDetails.wfh : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                    borderRight: "1px solid transparent",
                  }}
                  onClick={() => {
                    setJulyLeaveAbsentDetails(julyLeaveDetails.absentDetail)
                    setJulyLeaveAbsent(true)
                  }}
                >
                  {!isEmpty(julyLeaveDetails) ? julyLeaveDetails.absent : 0}
                </th>
              </thead>
            </table>
          ),
          augustLeave: (
            <table style={{ marginBottom: "-12px", marginTop: "-12px" }}>
              <thead>
                <th
                  style={{
                    padding: "22px 13px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setAugLeaveCLDetails(augustLeaveDetails.clDetail)
                    setAugLeaveCL(true)
                  }}
                >
                  {!isEmpty(augustLeaveDetails) ? augustLeaveDetails.cl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 11.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setAugLeaveSLDetails(augustLeaveDetails.slDetail)
                    setAugLeaveSL(true)
                  }}
                >
                  {!isEmpty(augustLeaveDetails) ? augustLeaveDetails.sl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 13px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setAugLeaveGLDetails(augustLeaveDetails.glDetail)
                    setAugLeaveGL(true)
                  }}
                >
                  {!isEmpty(augustLeaveDetails) ? augustLeaveDetails.gl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 16.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setAugPermissionDetails(augustLeaveDetails.permissionDetail)
                    setAugPermission(true)
                  }}
                >
                  {!isEmpty(augustLeaveDetails)
                    ? augustLeaveDetails.permission
                    : 0}
                </th>
                <th
                  style={{
                    padding: "22px 19px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setAugDelegationDetails(augustLeaveDetails.delegationDetail)
                    setAugDelegation(true)
                  }}
                >
                  {!isEmpty(augustLeaveDetails)
                    ? augustLeaveDetails.delegation
                    : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setAugNightShiftDetails(augustLeaveDetails.nightShiftDetail)
                    setAugNightShift(true)
                  }}
                >
                  {!isEmpty(augustLeaveDetails)
                    ? augustLeaveDetails.nightShift
                    : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15.5px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setAugWfhDetails(augustLeaveDetails.wfhDetail)
                    setAugWfh(true)
                  }}
                >
                  {!isEmpty(augustLeaveDetails.wfh)
                    ? augustLeaveDetails.wfh
                    : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                    borderRight: "1px solid transparent",
                  }}
                  onClick={() => {
                    setAugLeaveAbsentDetails(augustLeaveDetails.absentDetail)
                    setAugLeaveAbsent(true)
                  }}
                >
                  {!isEmpty(augustLeaveDetails) ? augustLeaveDetails.absent : 0}
                </th>
              </thead>
            </table>
          ),
          sepLeave: (
            <table style={{ marginBottom: "-12px", marginTop: "-12px" }}>
              <thead>
                <th
                  style={{
                    padding: "22px 13px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setSepLeaveCLDetails(sepLeaveDetails.clDetail)
                    setSepLeaveCL(true)
                  }}
                >
                  {!isEmpty(sepLeaveDetails) ? sepLeaveDetails.cl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 11.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setSepLeaveSLDetails(sepLeaveDetails.slDetail)
                    setSepLeaveSL(true)
                  }}
                >
                  {!isEmpty(sepLeaveDetails) ? sepLeaveDetails.sl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 13px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setSepLeaveGLDetails(sepLeaveDetails.glDetail)
                    setSepLeaveGL(true)
                  }}
                >
                  {!isEmpty(sepLeaveDetails) ? sepLeaveDetails.gl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 16.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setSepPermissionDetails(sepLeaveDetails.permissionDetail)
                    setSepPermission(true)
                  }}
                >
                  {!isEmpty(sepLeaveDetails) ? sepLeaveDetails.permission : 0}
                </th>
                <th
                  style={{
                    padding: "22px 19px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setSepDelegationDetails(sepLeaveDetails.delegationDetail)
                    setSepDelegation(true)
                  }}
                >
                  {!isEmpty(sepLeaveDetails) ? sepLeaveDetails.delegation : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setSepNightShiftDetails(sepLeaveDetails.nightShiftDetail)
                    setSepNightShift(true)
                  }}
                >
                  {!isEmpty(sepLeaveDetails) ? sepLeaveDetails.nightShift : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15.5px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setSepWfhDetails(sepLeaveDetails.wfhDetail)
                    setSepWfh(true)
                  }}
                >
                  {!isEmpty(sepLeaveDetails.wfh) ? sepLeaveDetails.wfh : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                    borderRight: "1px solid transparent",
                  }}
                  onClick={() => {
                    setSepLeaveAbsentDetails(sepLeaveDetails.absentDetail)
                    setSepLeaveAbsent(true)
                  }}
                >
                  {!isEmpty(sepLeaveDetails) ? sepLeaveDetails.absent : 0}
                </th>
              </thead>
            </table>
          ),
          octLeave: (
            <table style={{ marginBottom: "-12px", marginTop: "-12px" }}>
              <thead>
                <th
                  style={{
                    padding: "22px 13px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setOctLeaveCLDetails(octLeaveDetails.clDetail)
                    setOctLeaveCL(true)
                  }}
                >
                  {!isEmpty(octLeaveDetails) ? octLeaveDetails.cl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 11.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setOctLeaveSLDetails(octLeaveDetails.slDetail)
                    setOctLeaveSL(true)
                  }}
                >
                  {!isEmpty(octLeaveDetails) ? octLeaveDetails.sl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 13px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setOctLeaveGLDetails(octLeaveDetails.glDetail)
                    setOctLeaveGL(true)
                  }}
                >
                  {!isEmpty(octLeaveDetails) ? octLeaveDetails.gl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 16.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setOctPermissionDetails(octLeaveDetails.permissionDetail)
                    setOctPermission(true)
                  }}
                >
                  {!isEmpty(octLeaveDetails) ? octLeaveDetails.permission : 0}
                </th>
                <th
                  style={{
                    padding: "22px 19px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setOctDelegationDetails(octLeaveDetails.delegationDetail)
                    setOctDelegation(true)
                  }}
                >
                  {!isEmpty(octLeaveDetails) ? octLeaveDetails.delegation : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setOctNightShiftDetails(octLeaveDetails.nightShiftDetail)
                    setOctNightShift(true)
                  }}
                >
                  {!isEmpty(octLeaveDetails) ? octLeaveDetails.nightShift : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15.5px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setOctWfhDetails(octLeaveDetails.wfhDetail)
                    setOctWfh(true)
                  }}
                >
                  {!isEmpty(octLeaveDetails.wfh) ? octLeaveDetails.wfh : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                    borderRight: "1px solid transparent",
                  }}
                  onClick={() => {
                    setOctLeaveAbsentDetails(octLeaveDetails.absentDetail)
                    setOctLeaveAbsent(true)
                  }}
                >
                  {!isEmpty(octLeaveDetails) ? octLeaveDetails.absent : 0}
                </th>
              </thead>
            </table>
          ),
          novLeave: (
            <table style={{ marginBottom: "-12px", marginTop: "-12px" }}>
              <thead>
                <th
                  style={{
                    padding: "22px 13px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setNovLeaveCLDetails(novLeaveDetails.clDetail)
                    setNovLeaveCL(true)
                  }}
                >
                  {!isEmpty(novLeaveDetails) ? novLeaveDetails.cl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 11.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setNovLeaveSLDetails(novLeaveDetails.slDetail)
                    setNovLeaveSL(true)
                  }}
                >
                  {!isEmpty(novLeaveDetails) ? novLeaveDetails.sl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 13px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setNovLeaveGLDetails(novLeaveDetails.glDetail)
                    setNovLeaveGL(true)
                  }}
                >
                  {!isEmpty(novLeaveDetails) ? novLeaveDetails.gl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 16.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setNovPermissionDetails(novLeaveDetails.permissionDetail)
                    setNovPermission(true)
                  }}
                >
                  {!isEmpty(novLeaveDetails) ? novLeaveDetails.permission : 0}
                </th>
                <th
                  style={{
                    padding: "22px 19px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setNovDelegationDetails(novLeaveDetails.delegationDetail)
                    setNovDelegation(true)
                  }}
                >
                  {!isEmpty(novLeaveDetails) ? novLeaveDetails.delegation : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setNovNightShiftDetails(novLeaveDetails.nightShiftDetail)
                    setNovNightShift(true)
                  }}
                >
                  {!isEmpty(novLeaveDetails) ? novLeaveDetails.nightShift : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15.5px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setNovWfhDetails(novLeaveDetails.wfhDetail)
                    setNovWfh(true)
                  }}
                >
                  {!isEmpty(novLeaveDetails.wfh) ? novLeaveDetails.wfh : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                    borderRight: "1px solid transparent",
                  }}
                  onClick={() => {
                    setNovLeaveAbsentDetails(novLeaveDetails.absentDetail)
                    setNovLeaveAbsent(true)
                  }}
                >
                  {!isEmpty(novLeaveDetails) ? novLeaveDetails.absent : 0}
                </th>
              </thead>
            </table>
          ),
          decLeave: (
            <table style={{ marginBottom: "-12px", marginTop: "-12px" }}>
              <thead>
                <th
                  style={{
                    padding: "22px 13px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setDecLeaveCLDetails(decLeaveDetails.clDetail)
                    setDecLeaveCL(true)
                  }}
                >
                  {!isEmpty(decLeaveDetails) ? decLeaveDetails.cl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 11.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setDecLeaveSLDetails(decLeaveDetails.slDetail)
                    setDecLeaveSL(true)
                  }}
                >
                  {!isEmpty(decLeaveDetails) ? decLeaveDetails.sl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 13px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setDecLeaveGLDetails(decLeaveDetails.glDetail)
                    setDecLeaveGL(true)
                  }}
                >
                  {!isEmpty(decLeaveDetails) ? decLeaveDetails.gl : 0}
                </th>
                <th
                  style={{
                    padding: "22px 16.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setDecPermissionDetails(decLeaveDetails.permissionDetail)
                    setDecPermission(true)
                  }}
                >
                  {!isEmpty(decLeaveDetails) ? decLeaveDetails.permission : 0}
                </th>
                <th
                  style={{
                    padding: "22px 19px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setDecDelegationDetails(decLeaveDetails.delegationDetail)
                    setDecDelegation(true)
                  }}
                >
                  {!isEmpty(decLeaveDetails) ? decLeaveDetails.delegation : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15.5px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                  }}
                  onClick={() => {
                    setDecNightShiftDetails(decLeaveDetails.nightShiftDetail)
                    setDecNightShift(true)
                  }}
                >
                  {!isEmpty(decLeaveDetails) ? decLeaveDetails.nightShift : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15.5px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setDecWfhDetails(decLeaveDetails.wfhDetail)
                    setDecWfh(true)
                  }}
                >
                  {!isEmpty(decLeaveDetails.wfh) ? decLeaveDetails.wfh : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15px",
                    borderLeft: "none",
                    color: "#E40D8C",
                    borderBottom: "none",
                    borderTop: "none",
                    borderRight: "1px solid transparent",
                  }}
                  onClick={() => {
                    setDecLeaveAbsentDetails(decLeaveDetails.absentDetail)
                    setDecLeaveAbsent(true)
                  }}
                >
                  {!isEmpty(decLeaveDetails) ? decLeaveDetails.absent : 0}
                </th>
              </thead>
            </table>
          ),
          totalLeave: (
            <table style={{ marginBottom: "-12px", marginTop: "-12px" }}>
              <thead>
                <th
                  style={{
                    padding: "22px",
                    // fontSize: "12px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                  }}
                >
                  {!isEmpty(totalLeaveDetails)
                    ? Math.round(totalLeaveDetails.totalCl)
                    : 0}
                </th>
                <th
                  style={{
                    padding: "22px",
                    // fontSize: "12px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                  }}
                >
                  {!isEmpty(totalLeaveDetails)
                    ? Math.round(totalLeaveDetails.totalSl)
                    : 0}
                </th>
                <th
                  style={{
                    padding: "22px",
                    // fontSize: "12px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                  }}
                >
                  {!isEmpty(totalLeaveDetails)
                    ? Math.round(totalLeaveDetails.totalGl)
                    : 0}
                </th>
                <th
                  style={{
                    padding: "22px",
                    // fontSize: "12px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                  }}
                >
                  {!isEmpty(totalLeaveDetails)
                    ? Math.round(totalLeaveDetails.totalPermission)
                    : 0}
                </th>
                <th
                  style={{
                    padding: "22px",
                    // fontSize: "12px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                  }}
                >
                  {!isEmpty(totalLeaveDetails)
                    ? Math.round(totalLeaveDetails.totalDelegation)
                    : 0}
                </th>
                <th
                  style={{
                    padding: "22px",
                    // fontSize: "12px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                  }}
                >
                  {!isEmpty(totalLeaveDetails)
                    ? Math.round(totalLeaveDetails.totalNightShift)
                    : 0}
                </th>
                <th
                  style={{
                    padding: "22px 15.5px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                    cursor: "pointer",
                  }}
                >
                  {!isEmpty(totalLeaveDetails.wfh) ? totalLeaveDetails.wfh : 0}
                </th>
                <th
                  style={{
                    padding: "22px",
                    // fontSize: "12px",
                    borderLeft: "none",
                    borderBottom: "none",
                    borderTop: "none",
                    color: "#E40D8C",
                    borderRight: "1px solid transparent",
                  }}
                >
                  {!isEmpty(totalLeaveDetails)
                    ? Math.round(totalLeaveDetails.totalAbsent)
                    : 0}
                </th>
              </thead>
            </table>
          ),
          duration: employeeRecord.duration,
          toDate: toDateTime,
          key: index,
        }
      })
    : []

  const HeaderTable = () => {
    return (
      <table style={{ marginBottom: "-16px", marginTop: "-16px" }}>
        <thead>
          <th
            className="month-wise-leave-details"
            style={{ borderLeft: "none" }}
          >
            CL
          </th>
          <th className="month-wise-leave-details">SL</th>
          <th className="month-wise-leave-details">GL</th>
          <th className="month-wise-leave-details">PER</th>
          <th className="month-wise-leave-details">DELE</th>
          <th className="month-wise-leave-details">NS</th>
          <th className="month-wise-leave-details">WFH</th>
          <th
            className="month-wise-emp-details"
            style={{ borderRight: "1px solid transparent" }}
          >
            EMP DEF
          </th>
        </thead>
      </table>
    )
  }
  const TotalHeaderTable = () => {
    return (
      <table style={{ marginBottom: "-16px", marginTop: "-16px" }}>
        <thead>
          <th
            className="total-year-wise-leave-details"
            style={{ borderLeft: "none" }}
          >
            CL
          </th>
          <th className="total-year-wise-leave-details">SL</th>
          <th className="total-year-wise-leave-details">GL</th>
          <th className="total-year-wise-leave-details">PER</th>
          <th className="total-year-wise-leave-details">DELE</th>
          <th className="total-year-wise-leave-details">NS</th>
          <th className="total-year-wise-leave-details">WFH</th>
          <th
            className="month-wise-emp-details"
            style={{ borderRight: "1px solid transparent" }}
          >
            EMP DEF
          </th>
        </thead>
      </table>
    )
  }

  const year = moment().format("YYYY")

  //pagination table
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    // {
    //   dataField: "action",
    //   text: "Action",
    // },
    {
      dataField: "employeeCode",
      text: "Employee Code",
      sort: true,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "employeeName",
      text: "Employee Name",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "companyName",
      text: "Company",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch",
      sort: true,
      headerStyle: {
        minWidth: "110px",
      },
    },
    {
      dataField: "departmentName",
      text: "Department",
      sort: true,
      headerStyle: {
        minWidth: "125px",
      },
    },
    {
      dataField: "designationName",
      text: "Designation",
      sort: true,
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "janLeave",
      text: (
        <div>
          <div>
            <h4 style={{ textAlign: "center" }}>JAN - {year}</h4>
            <hr className="month-wise-table-header"></hr>
          </div>
          <HeaderTable />
        </div>
      ),
      // sort: true,
      headerStyle: {
        minWidth: "160px",
        marginLeft: "-20px",
      },
    },
    {
      dataField: "febLeave",
      text: (
        <div>
          <div>
            <h4 style={{ textAlign: "center" }}>FEB - {year}</h4>
            <hr className="month-wise-table-header"></hr>
          </div>
          <HeaderTable />
        </div>
      ),
      // sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "marLeave",
      text: (
        <div>
          <div>
            <h4 style={{ textAlign: "center" }}>MAR - {year}</h4>
            <hr className="month-wise-table-header"></hr>
          </div>
          <HeaderTable />
        </div>
      ),
      // sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "aprLeave",
      text: (
        <div>
          <div>
            <h4 style={{ textAlign: "center" }}>APR - {year}</h4>
            <hr className="month-wise-table-header"></hr>
          </div>
          <HeaderTable />
        </div>
      ),
      // sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "mayLeave",
      text: (
        <div>
          <div>
            <h4 style={{ textAlign: "center" }}>MAY - {year}</h4>
            <hr className="month-wise-table-header"></hr>
          </div>
          <HeaderTable />
        </div>
      ),
      // sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "juneLeave",
      text: (
        <div>
          <div>
            <h4 style={{ textAlign: "center" }}>JUNE - {year}</h4>
            <hr className="month-wise-table-header"></hr>
          </div>
          <HeaderTable />
        </div>
      ),
      // sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "julyLeave",
      text: (
        <div>
          <div>
            <h4 style={{ textAlign: "center" }}>JULY - {year}</h4>
            <hr className="month-wise-table-header"></hr>
          </div>
          <HeaderTable />
        </div>
      ),
      // sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "augustLeave",
      text: (
        <div>
          <div>
            <h4 style={{ textAlign: "center" }}>AUG - {year}</h4>
            <hr className="month-wise-table-header"></hr>
          </div>
          <HeaderTable />
        </div>
      ),
      // sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "sepLeave",
      text: (
        <div>
          <div>
            <h4 style={{ textAlign: "center" }}>SEP - {year}</h4>
            <hr className="month-wise-table-header"></hr>
          </div>
          <HeaderTable />
        </div>
      ),
      // sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "octLeave",
      text: (
        <div>
          <div>
            <h4 style={{ textAlign: "center" }}>OCT - {year}</h4>
            <hr className="month-wise-table-header"></hr>
          </div>
          <HeaderTable />
        </div>
      ),
      // sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "novLeave",
      text: (
        <div>
          <div>
            <h4 style={{ textAlign: "center" }}>NOV - {year}</h4>
            <hr className="month-wise-table-header"></hr>
          </div>
          <HeaderTable />
        </div>
      ),
      // sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "decLeave",
      text: (
        <div>
          <div>
            <h4 style={{ textAlign: "center" }}>DEC - {year}</h4>
            <hr className="month-wise-table-header"></hr>
          </div>
          <HeaderTable />
        </div>
      ),
      // sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "totalLeave",
      text: (
        <div>
          <div>
            <h4 style={{ textAlign: "center" }}>Total</h4>
            <hr className="total-year-wise-table-header"></hr>
          </div>
          <TotalHeaderTable />
        </div>
      ),
      // sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
  ]

  console.log(startingDay, "startingDay")
  console.log(nextYearList, "nextYearList")
  // console.log(today, "today")
  const resetFormDetails = () => {
    setDepartmentlist([])
    setEmployeeCode([])
    setCompanies([])
    setBranches([])
    setDesignation([])
    // setLeaveTypeList([])
    setEmployeeRecordData({
      fromDate: startingDay,
    })
    dispatch(
      employeeRecordAction.loadEmployeeRecord({
        year: currentYear,
        page: pageChange ? pageCount : 1,
        limit: 50,
      })
    )
  }

  useEffect(() => {
    setTimeout(() => {
      if (applyFilter === false) {
        setEmployeeRecordData({
          ...employeeRecordData,
          fromDate: startingDay,
        })
      }
    }, 2000)
  }, [applyFilter])

  //PAGING FOR MANAGE OBS LEAD

  //download feature in data table

  // pagination options
  const [loading, setLoading] = useState(false)
  const [downloadLoading, setDownloadLoading] = useState(false)
  const MySearch = (props) => {
    let input

    const handleClick = () => {
      props.onSearch(input.value)
      console.log(input.value, "inputs")

      dispatch(
        employeeRecordAction.loadEmployeeRecord({
          searchFilter: input.value,
          year: currentYear,
          page: pageChange ? pageCount : 1,
          limit: 50,
        })
      )
      console.log(input.value, "input")
    }
    return (
      <div className="d-flex flex-row">
        <input
          className="form-control"
          placeholder="Search"
          ref={(n) => (input = n)}
          type="text"
        />
        <button className="btn btn-success mx-2" onClick={handleClick}>
          <i className="fas fa-search"></i>
        </button>
      </div>
    )
  }

  //Export CSV Functionality
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }
  const exportToCsv = () => {
    if (
      !isEmpty(departmentlist) ||
      !isEmpty(branch) ||
      !isEmpty(company) ||
      !isEmpty(employeeCode) ||
      !isEmpty(employeeRecordData.fromDate) ||
      !isEmpty(employeeRecordData.toDate)
    ) {
      var searchCompany = company && company ? company : ""
      var searchBranch = branch && branch ? branch : ""
      var searchDepartment =
        departmentlist && departmentlist.value ? [departmentlist.value] : ""
      var searchDesignation =
        designation && designation.value ? [designation.value] : ""

      var searchEmpCode =
        employeeCode && employeeCode.empCode ? employeeCode.empCode : ""
      var searchEmpId =
        employeeCode && employeeCode.value ? employeeCode.value : ""

      var searchFromDateDetails =
        employeeRecordData && employeeRecordData.fromDate
          ? moment(employeeRecordData.fromDate).format("YYYY")
          : ""
      var searchFromDate = parseInt(searchFromDateDetails)

      var searchvalue = {}
      searchvalue.page = pageChange ? pageCount : 1
      searchvalue.limit = 50

      if (searchCompany) {
        searchvalue.company = searchCompany
      }
      if (searchBranch) {
        searchvalue.branch = searchBranch
      }
      if (searchDepartment) {
        searchvalue.department = searchDepartment
      }
      if (searchDesignation) {
        searchvalue.designation = searchDesignation
      }
      if (searchEmpCode) {
        searchvalue.empCode = searchEmpCode
      }
      if (searchEmpId) {
        searchvalue.empId = searchEmpId
      }
      if (searchFromDate) {
        searchvalue.year = searchFromDate
      }
      // if (searchStatus) {
      //   searchvalue.leaveStatus = searchStatus
      // }

      // specificDispatch(employeeRecordAction.loadEmployeeRecord(searchvalue))
      setDownloadLoading(true)
      api
        .post(`/getEmployeeCurrentRecordForMonthlyExportExcel`, searchvalue)
        .then((response) => {
          console.log(response, "response")
          const employeeRecordsTable = !isEmpty(response.data.Data)
            ? response.data.Data.map((employeeRecord, index) => {
                // slNo = slNo + 1

                var str = !isEmpty(employeeRecord.attachment)
                  ? employeeRecord.attachment
                  : []
                const fileUrl = isEmpty(str)
                  ? ""
                  : str.substring(str.indexOf("/"))
                const attachments = isEmpty(fileUrl)
                  ? ""
                  : "https://api.alphaone.app/uploads/" + fileUrl
                console.log(attachments, "attachment with alpha url")
                var fromDateTime = !isEmpty(employeeRecord.fromDate)
                  ? moment(employeeRecord.fromDate)
                      .subtract(5, "hours")
                      .subtract(30, "minutes")
                      .format("DD-MM-YYYY")
                  : []

                var toDateTime = !isEmpty(employeeRecord.toDate)
                  ? moment(employeeRecord.toDate)
                      .subtract(5, "hours")
                      .subtract(30, "minutes")
                      .format("DD-MM-YYYY")
                  : []
                const janLeaveDetails =
                  !isEmpty(employeeRecord) && employeeRecord.leaveDetails
                    ? employeeRecord.leaveDetails.find(
                        (data) => data.month == "January"
                      )
                    : []
                const febLeaveDetails =
                  !isEmpty(employeeRecord) && employeeRecord.leaveDetails
                    ? employeeRecord.leaveDetails.find(
                        (data) => data.month == "February"
                      )
                    : []
                const marLeaveDetails =
                  !isEmpty(employeeRecord) && employeeRecord.leaveDetails
                    ? employeeRecord.leaveDetails.find(
                        (data) => data.month == "March"
                      )
                    : []
                const aprLeaveDetails =
                  !isEmpty(employeeRecord) && employeeRecord.leaveDetails
                    ? employeeRecord.leaveDetails.find(
                        (data) => data.month == "April"
                      )
                    : []
                const mayLeaveDetails =
                  !isEmpty(employeeRecord) && employeeRecord.leaveDetails
                    ? employeeRecord.leaveDetails.find(
                        (data) => data.month == "May"
                      )
                    : []
                const juneLeaveDetails =
                  !isEmpty(employeeRecord) && employeeRecord.leaveDetails
                    ? employeeRecord.leaveDetails.find(
                        (data) => data.month == "June"
                      )
                    : []
                const julyLeaveDetails =
                  !isEmpty(employeeRecord) && employeeRecord.leaveDetails
                    ? employeeRecord.leaveDetails.find(
                        (data) => data.month == "July"
                      )
                    : []
                const augustLeaveDetails =
                  !isEmpty(employeeRecord) && employeeRecord.leaveDetails
                    ? employeeRecord.leaveDetails.find(
                        (data) => data.month == "August"
                      )
                    : []
                const sepLeaveDetails =
                  !isEmpty(employeeRecord) && employeeRecord.leaveDetails
                    ? employeeRecord.leaveDetails.find(
                        (data) => data.month == "September"
                      )
                    : []
                const octLeaveDetails =
                  !isEmpty(employeeRecord) && employeeRecord.leaveDetails
                    ? employeeRecord.leaveDetails.find(
                        (data) => data.month == "October"
                      )
                    : []
                const novLeaveDetails =
                  !isEmpty(employeeRecord) && employeeRecord.leaveDetails
                    ? employeeRecord.leaveDetails.find(
                        (data) => data.month == "November"
                      )
                    : []
                const decLeaveDetails =
                  !isEmpty(employeeRecord) && employeeRecord.leaveDetails
                    ? employeeRecord.leaveDetails.find(
                        (data) => data.month == "December"
                      )
                    : []
                const totalLeaveDetails =
                  !isEmpty(employeeRecord) && employeeRecord.leaveDetails
                    ? employeeRecord.leaveDetails.find(
                        (data) => data.type == "total-values"
                      )
                    : []
                console.log(janLeaveDetails, "janLeaveDetails")

                return {
                  _id: employeeRecord._id,
                  sNo: index + 1,
                  branchId: employeeRecord.branchId,
                  branchName: employeeRecord.branchName,
                  companyId: employeeRecord.companyId,
                  companyName: employeeRecord.companyName,
                  departmentId: employeeRecord.departmentId,
                  departmentName: employeeRecord.departmentName,
                  designationId: employeeRecord.designationId,
                  designationName: employeeRecord.designationName,
                  employeeCode: employeeRecord.employeeCode,
                  employeeName: employeeRecord.employeeName,
                  workingDays: employeeRecord.workingDays,
                  fromDate: fromDateTime,
                  leaveDetails: employeeRecord.leaveDetails,
                  janLeave:
                    `${janLeaveDetails.cl} ${"(CL)"} ${"|"}` +
                    `${janLeaveDetails.sl} ${"(SL)"} ${"|"}` +
                    `${janLeaveDetails.gl} ${"(GL)"} ${"|"}` +
                    `${janLeaveDetails.permission} ${"(Per)"} ${"|"}` +
                    `${janLeaveDetails.delegation} ${"(Del)"} ${"|"}` +
                    `${janLeaveDetails.nightShift} ${"(NS)"} ${"|"}` +
                    `${janLeaveDetails.wfh} ${"(WFH)"} ${"|"}` +
                    `${janLeaveDetails.absent} ${"(E-D)"}`,
                  febLeave:
                    `${febLeaveDetails.cl} ${"(CL)"} ${"|"}` +
                    `${febLeaveDetails.sl} ${"(SL)"} ${"|"}` +
                    `${febLeaveDetails.gl} ${"(GL)"} ${"|"}` +
                    `${febLeaveDetails.permission} ${"(Per)"} ${"|"}` +
                    `${febLeaveDetails.delegation} ${"(Del)"} ${"|"}` +
                    `${febLeaveDetails.nightShift} ${"(NS)"} ${"|"}` +
                    `${febLeaveDetails.wfh} ${"(WFH)"} ${"|"}` +
                    `${febLeaveDetails.absent} ${"(E-D)"}`,
                  marLeave:
                    `${marLeaveDetails.cl} ${"(CL)"} ${"|"}` +
                    `${marLeaveDetails.sl} ${"(SL)"} ${"|"}` +
                    `${marLeaveDetails.gl} ${"(GL)"} ${"|"}` +
                    `${marLeaveDetails.permission} ${"(Per)"} ${"|"}` +
                    `${marLeaveDetails.delegation} ${"(Del)"} ${"|"}` +
                    `${marLeaveDetails.nightShift} ${"(NS)"} ${"|"}` +
                    `${marLeaveDetails.wfh} ${"(WFH)"} ${"|"}` +
                    `${marLeaveDetails.absent} ${"(E-D)"}`,
                  aprLeave:
                    `${aprLeaveDetails.cl} ${"(CL)"} ${"|"}` +
                    `${aprLeaveDetails.sl} ${"(SL)"} ${"|"}` +
                    `${aprLeaveDetails.gl} ${"(GL)"} ${"|"}` +
                    `${aprLeaveDetails.permission} ${"(Per)"} ${"|"}` +
                    `${aprLeaveDetails.delegation} ${"(Del)"} ${"|"}` +
                    `${aprLeaveDetails.nightShift} ${"(NS)"} ${"|"}` +
                    `${aprLeaveDetails.wfh} ${"(WFH)"} ${"|"}` +
                    `${aprLeaveDetails.absent} ${"(E-D)"}`,
                  mayLeave:
                    `${mayLeaveDetails.cl} ${"(CL)"} ${"|"}` +
                    `${mayLeaveDetails.sl} ${"(SL)"} ${"|"}` +
                    `${mayLeaveDetails.gl} ${"(GL)"} ${"|"}` +
                    `${mayLeaveDetails.permission} ${"(Per)"} ${"|"}` +
                    `${mayLeaveDetails.delegation} ${"(Del)"} ${"|"}` +
                    `${mayLeaveDetails.nightShift} ${"(NS)"} ${"|"}` +
                    `${mayLeaveDetails.wfh} ${"(WFH)"} ${"|"}` +
                    `${mayLeaveDetails.absent} ${"(E-D)"}`,
                  juneLeave:
                    `${juneLeaveDetails.cl} ${"(CL)"} ${"|"}` +
                    `${juneLeaveDetails.sl} ${"(SL)"} ${"|"}` +
                    `${juneLeaveDetails.gl} ${"(GL)"} ${"|"}` +
                    `${juneLeaveDetails.permission} ${"(Per)"} ${"|"}` +
                    `${juneLeaveDetails.delegation} ${"(Del)"} ${"|"}` +
                    `${juneLeaveDetails.nightShift} ${"(NS)"} ${"|"}` +
                    `${juneLeaveDetails.wfh} ${"(WFH)"} ${"|"}` +
                    `${juneLeaveDetails.absent} ${"(E-D)"}`,
                  julyLeave:
                    `${julyLeaveDetails.cl} ${"(CL)"} ${"|"}` +
                    `${julyLeaveDetails.sl} ${"(SL)"} ${"|"}` +
                    `${julyLeaveDetails.gl} ${"(GL)"} ${"|"}` +
                    `${julyLeaveDetails.permission} ${"(Per)"} ${"|"}` +
                    `${julyLeaveDetails.delegation} ${"(Del)"} ${"|"}` +
                    `${julyLeaveDetails.nightShift} ${"(NS)"} ${"|"}` +
                    `${julyLeaveDetails.wfh} ${"(WFH)"} ${"|"}` +
                    `${julyLeaveDetails.absent} ${"(E-D)"}`,
                  augLeave:
                    `${augustLeaveDetails.cl} ${"(CL)"} ${"|"}` +
                    `${augustLeaveDetails.sl} ${"(SL)"} ${"|"}` +
                    `${augustLeaveDetails.gl} ${"(GL)"} ${"|"}` +
                    `${augustLeaveDetails.permission} ${"(Per)"} ${"|"}` +
                    `${augustLeaveDetails.delegation} ${"(Del)"} ${"|"}` +
                    `${augustLeaveDetails.nightShift} ${"(NS)"} ${"|"}` +
                    `${augustLeaveDetails.wfh} ${"(WFH)"} ${"|"}` +
                    `${augustLeaveDetails.absent} ${"(E-D)"}`,
                  sepLeave:
                    `${sepLeaveDetails.cl} ${"(CL)"} ${"|"}` +
                    `${sepLeaveDetails.sl} ${"(SL)"} ${"|"}` +
                    `${sepLeaveDetails.gl} ${"(GL)"} ${"|"}` +
                    `${sepLeaveDetails.permission} ${"(Per)"} ${"|"}` +
                    `${sepLeaveDetails.delegation} ${"(Del)"} ${"|"}` +
                    `${sepLeaveDetails.nightShift} ${"(NS)"} ${"|"}` +
                    `${sepLeaveDetails.wfh} ${"(WFH)"} ${"|"}` +
                    `${sepLeaveDetails.absent} ${"(E-D)"}`,
                  octLeave:
                    `${octLeaveDetails.cl} ${"(CL)"} ${"|"}` +
                    `${octLeaveDetails.sl} ${"(SL)"} ${"|"}` +
                    `${octLeaveDetails.gl} ${"(GL)"} ${"|"}` +
                    `${octLeaveDetails.permission} ${"(Per)"} ${"|"}` +
                    `${octLeaveDetails.delegation} ${"(Del)"} ${"|"}` +
                    `${octLeaveDetails.nightShift} ${"(NS)"} ${"|"}` +
                    `${octLeaveDetails.wfh} ${"(WFH)"} ${"|"}` +
                    `${octLeaveDetails.absent} ${"(E-D)"}`,
                  novLeave:
                    `${novLeaveDetails.cl} ${"(CL)"} ${"|"}` +
                    `${novLeaveDetails.sl} ${"(SL)"} ${"|"}` +
                    `${novLeaveDetails.gl} ${"(GL)"} ${"|"}` +
                    `${novLeaveDetails.permission} ${"(Per)"} ${"|"}` +
                    `${novLeaveDetails.delegation} ${"(Del)"} ${"|"}` +
                    `${novLeaveDetails.nightShift} ${"(NS)"} ${"|"}` +
                    `${novLeaveDetails.wfh} ${"(WFH)"} ${"|"}` +
                    `${novLeaveDetails.absent} ${"(E-D)"}`,
                  decLeave:
                    `${decLeaveDetails.cl} ${"(CL)"} ${"|"}` +
                    `${decLeaveDetails.sl} ${"(SL)"} ${"|"}` +
                    `${decLeaveDetails.gl} ${"(GL)"} ${"|"}` +
                    `${decLeaveDetails.permission} ${"(Per)"} ${"|"}` +
                    `${decLeaveDetails.delegation} ${"(Del)"} ${"|"}` +
                    `${decLeaveDetails.nightShift} ${"(NS)"} ${"|"}` +
                    `${decLeaveDetails.wfh} ${"(WFH)"} ${"|"}` +
                    `${decLeaveDetails.absent} ${"(E-D)"}`,
                  totalLeave:
                    `${Math.round(
                      totalLeaveDetails.totalCl
                    )} ${"(CL)"} ${"|"}` +
                    `${Math.round(
                      totalLeaveDetails.totalSl
                    )} ${"(SL)"} ${"|"}` +
                    `${Math.round(
                      totalLeaveDetails.totalGl
                    )} ${"(GL)"} ${"|"}` +
                    `${Math.round(
                      totalLeaveDetails.totalPermission
                    )} ${"(Per)"} ${"|"}` +
                    `${Math.round(
                      totalLeaveDetails.totalDelegation
                    )} ${"(Del)"} ${"|"}` +
                    `${Math.round(
                      totalLeaveDetails.totalNightShift
                    )} ${"(NS)"} ${"|"}` +
                    `${Math.round(
                      totalLeaveDetails.totalWfh
                    )} ${"(WFH)"} ${"|"}` +
                    `${Math.round(totalLeaveDetails.totalAbsent)} ${"(E-D)"}`,

                  duration: employeeRecord.duration,
                  toDate: toDateTime,

                  key: index,
                }
              })
            : []
          // setBtnLoader(true)
          setTimeout(() => {
            let headerData = [
              `SNo, Employee Code, Employee Name, Company Name, Branch Name,Department Name, Designation Name, January , February, March, April, May, June, July, August, September, October, November, December, Total`,
            ]

            let usersCsv =
              !isEmpty(employeeRecordsTable) &&
              employeeRecordsTable.reduce((acc, user) => {
                const {
                  sNo,
                  employeeCode,
                  employeeName,
                  companyName,
                  branchName,
                  departmentName,
                  designationName,
                  janLeave,
                  febLeave,
                  marLeave,
                  aprLeave,
                  mayLeave,
                  juneLeave,
                  julyLeave,
                  augustLeave,
                  septemberLeave,
                  octoberLeave,
                  novemberLeave,
                  decemberLeave,
                  totalLeave,
                } = user
                acc.push([
                  sNo,
                  employeeCode,
                  employeeName,
                  companyName,
                  branchName,
                  departmentName,
                  designationName,
                  janLeave,
                  febLeave,
                  marLeave,
                  aprLeave,
                  mayLeave,
                  juneLeave,
                  julyLeave,
                  augustLeave,
                  septemberLeave,
                  octoberLeave,
                  novemberLeave,
                  decemberLeave,
                  totalLeave,
                ])

                console.log("test", acc)
                return acc
              }, [])
            console.log(usersCsv, "usersCsv")
            downloadFile({
              data: [...headerData, ...usersCsv].join("\n"),
              fileName: "YearEmployeeRecord.csv",
              fileType: "text/csv",
            })
            setDownloadLoading(false)
          }, 3500)
        })
    }
  }

  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          // sort,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {(props) => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4">
                        <div className="d-flex flex-row ">
                          <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                            <div
                              className="position-relative mt-7"
                              style={searchBarStyle || null}
                            >
                              <MySearch {...props.searchProps} />
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </div>{" "}
                      </Col>
                      {/* {downloadAccessId === "61bc3079e2e60e9919697604" ? ( */}
                      <Col md="8">
                        <div
                          style={{
                            float: "right",
                          }}
                        >
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      </Col>
                      {/* ) : (
                        ""
                      )} */}
                      <Col>
                        <BootstrapTable
                          remote
                          // {...props.baseProps}
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          striped={true}
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone
                            // paginationTotalRenderer={leave_list.totalDataCount}
                            {...paginationProps}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )

  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: employeeRecordTable.length,
    data:
      !isEmpty(employeeRecordTable) && employeeRecordTable.length > 0
        ? employeeRecordTable.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (type, { page, currentIndex, sizePerPage }) => {
    setPageCount(page)
    setPageChange(true)
    // setPageLoad(!pageLoad)
    console.log(page, "page")
    let result =
      !isEmpty(employeeRecordTable) && employeeRecordTable.length > 0
        ? employeeRecordTable
        : []
    if (
      !isEmpty(departmentlist) ||
      !isEmpty(branch) ||
      !isEmpty(company) ||
      !isEmpty(employeeCode) ||
      !isEmpty(employeeRecordData.fromDate)
    ) {
      var searchCompany = company && company ? company : ""
      var searchBranch = branch && branch ? branch : ""
      var searchDepartment =
        departmentlist && departmentlist.value ? [departmentlist.value] : ""
      var searchDesignation =
        designation && designation.value ? [designation.value] : ""

      var searchEmpCode =
        employeeCode && employeeCode.empCode ? employeeCode.empCode : ""
      var searchEmpId =
        employeeCode && employeeCode.value ? employeeCode.value : ""

      var searchFromDateDetails =
        employeeRecordData && employeeRecordData.fromDate
          ? moment(employeeRecordData.fromDate).format("YYYY")
          : ""
      var searchFromDate = parseInt(searchFromDateDetails)
      var searchvalue = {}
      searchvalue.page = pageChange ? pageCount : 1
      searchvalue.limit = 50
      if (searchCompany) {
        searchvalue.company = searchCompany
      }
      if (searchBranch) {
        searchvalue.branch = searchBranch
      }
      if (searchDepartment) {
        searchvalue.department = searchDepartment
      }
      if (searchDesignation) {
        searchvalue.designation = searchDesignation
      }
      if (searchEmpCode) {
        searchvalue.empCode = searchEmpCode
      }
      if (searchEmpId) {
        searchvalue.empId = searchEmpId
      }
      if (searchFromDate) {
        searchvalue.year = searchFromDate
      }

      dispatch(employeeRecordAction.loadEmployeeRecord(searchvalue))
    } else {
      dispatch(
        employeeRecordAction.loadEmployeeRecord({
          year: currentYear,
          page: page,
          limit: sizePerPage,
        })
      )
      setLoading(true)
    }

    setTimeout(() => {
      setLoading(false)
    }, 2000)

    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={"Master"} breadcrumbItem={title} />

          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {" "}
                            {"Company"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="company"
                          isMulti
                          value={companies}
                          style={{ zIndex: 10000 }}
                          onChange={(e) => handleCompaniesChange(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branch"
                          isMulti
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          options={branchOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Department"}
                          >
                            {"Department"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="Department"
                          value={departmentlist}
                          onChange={(e) => setDepartmentlist(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.departmentOptions
                              : []
                          }
                          placeholder="Select Department"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Designation"}
                          >
                            {"Designation"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="designation"
                          value={designation}
                          onChange={(e) => setDesignation(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.designationOptions
                              : []
                          }
                          placeholder="Select Designation"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Employee Code"}
                          >
                            {"Employee Code"}
                          </Label>
                        </div>
                        <ReactSearchAutocomplete
                          name="employeeCode"
                          items={employeeOptions}
                          value={employeeCode}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => setEmployeeCode(e)}
                          onChange={(e) => setEmployeeCode(e.target.value)}
                          placeholder="Enter Employee Code"
                          fuseOptions={fuseOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 0,
                          }}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"Year"}
                          </Label>
                        </div>
                        <Input
                          type="month"
                          placeholder="YYYY"
                          name="fromDate"
                          max={employeeRecordData.toDate}
                          value={employeeRecordData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            className="btn btn-danger btn-label simple-form-Reset-btn mx-2"
                            onClick={() => resetFormDetails()}
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="button"
                            onClick={() => handleApply()}
                            className="btn btn-success btn-label simple-form-applyfilter-btn"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/*Table start*/}
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <RemotePagination
                    data={employeeRecordTable}
                    page={page}
                    sizePerPage={sizePerPage}
                    totalSize={employee_record.totalDataCount}
                    onTableChange={handleTableChange}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* Jan Leave */}
        {janLeaveCL && (
          <Modal show={janLeaveCL} onHide={handleJanLeaveCL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave CL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {janLeaveCLDetails && janLeaveCLDetails.length > 0 ? (
                          janLeaveCLDetails.map((cl, index) => {
                            const attachment = isEmpty(cl.attachments)
                              ? ""
                              : cl.attachments.substring(
                                  cl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(cl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(cl.toDate)
                              ? moment(cl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []

                            return (
                              <>
                                <tr key={cl._id}>
                                  <td>{index + 1}</td>
                                  <td>{cl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{cl.leaveDuration}</td>
                                  <td>{cl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(cl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={cl.attachments}>
                                        <audio controls>
                                          <source
                                            src={cl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(cl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{cl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleJanLeaveCL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {janLeaveSL && (
          <Modal show={janLeaveSL} onHide={handleJanLeaveSL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave SL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {janLeaveSLDetails && janLeaveSLDetails.length > 0 ? (
                          janLeaveSLDetails.map((sl, index) => {
                            const attachment = isEmpty(sl.attachments)
                              ? ""
                              : sl.attachments.substring(
                                  sl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(sl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(sl.toDate)
                              ? moment(sl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []
                            return (
                              <>
                                <tr key={sl._id}>
                                  <td>{index + 1}</td>
                                  <td>{sl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{sl.leaveDuration}</td>
                                  <td>{sl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(sl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={sl.attachments}>
                                        <audio controls>
                                          <source
                                            src={sl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(sl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{sl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleJanLeaveSL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {janLeaveGL && (
          <Modal show={janLeaveGL} onHide={handleJanLeaveGL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave GL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {janLeaveGLDetails && janLeaveGLDetails.length > 0 ? (
                          janLeaveGLDetails.map((gl, index) => {
                            const attachment = isEmpty(gl.attachments)
                              ? "--"
                              : gl.attachments.substring(
                                  gl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(gl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(gl.toDate)
                              ? moment(gl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []
                            return (
                              <>
                                <tr key={gl._id}>
                                  <td>{index + 1}</td>
                                  <td>{gl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{gl.leaveDuration}</td>
                                  <td>{gl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(gl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={gl.attachments}>
                                        <audio controls>
                                          <source
                                            src={gl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(gl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{gl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleJanLeaveGL}
              >
                Cancel
              </Button>
              {/* <Button
                       variant="primary"
                       className="btn btn-success"
                       onClick={() => {
                         handleLeaveGL()
                       }}
                     >
                       Submit
                     </Button> */}
            </Modal.Footer>
          </Modal>
        )}
        {permissionCount && (
          <Modal
            show={permissionCount}
            onHide={handlePermissionCount}
            size="lg"
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Permission Count</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {permissionDetails && permissionDetails.length > 0 ? (
                          permissionDetails.map((permission, index) => {
                            const attachment = isEmpty(permission.attachments)
                              ? ""
                              : permission.attachments.substring(
                                  permission.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(permission.date).format(
                              "DD-MM-YYYY"
                            )
                            return (
                              <>
                                <tr key={permission._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{permission.fromTime}</td>
                                  <td>{permission.toTime}</td>
                                  <td>{permission.duration}</td>
                                  <td>{permission.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            permission.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={permission.attachments}>
                                        <audio controls>
                                          <source
                                            src={permission.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(permission.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{permission.permissionStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handlePermissionCount}
              >
                Cancel
              </Button>
              {/* <Button
                       variant="primary"
                       className="btn btn-success"
                       onClick={() => {
                         handlePermissionCount()
                       }}
                     >
                       Submit
                     </Button> */}
            </Modal.Footer>
          </Modal>
        )}
        {leaveAbsent && (
          <Modal show={leaveAbsent} onHide={handleLeaveAbsent} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Leave Absent</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "50px" }}>Date</th>
                          <th style={{ width: "50px" }}>Absent Type</th>
                          <th style={{ width: "50px" }}>Request Type</th>
                          <th style={{ width: "50px" }}>Reason</th>
                          <th style={{ width: "50px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>From Date</th>
                          <th style={{ width: "50px" }}>To Date</th>
                          <th style={{ width: "50px" }}>Start Time</th>
                          <th style={{ width: "50px" }}>End Time</th>
                          <th style={{ width: "50px" }}>Duration</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {leaveAbsentDetails && leaveAbsentDetails.length > 0 ? (
                          leaveAbsentDetails.map((absent, index) => {
                            const attachment = isEmpty(absent.attachments)
                              ? ""
                              : absent.attachments.substring(
                                  absent.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(absent.date).format("DD-MM-YYYY")
                            var fromDate = isEmpty(absent.fromDate)
                              ? "--"
                              : moment(absent.fromDate).format("DD-MM-YYYY")

                            var toDate = isEmpty(absent.toDate)
                              ? "--"
                              : moment(absent.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")

                            return (
                              <>
                                <tr key={absent._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{absent.absentType}</td>
                                  <td>{absent.requestTypeId}</td>
                                  <td>{absent.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            absent.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={absent.attachments}>
                                        <audio controls>
                                          <source
                                            src={absent.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(absent.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{absent.fromTime}</td>
                                  <td>{absent.toTime}</td>
                                  <td>{absent.duration}</td>
                                  <td>{absent.absentStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={14}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleLeaveAbsent}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}

        {delegationCount && (
          <Modal
            show={delegationCount}
            onHide={handleDelegationAbsent}
            size="lg"
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Delegation Count</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {delegationDetails && delegationDetails.length > 0 ? (
                          delegationDetails.map((delegation, index) => {
                            const attachment = isEmpty(delegation.attachments)
                              ? "--"
                              : delegation.attachments.substring(
                                  delegation.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(delegation.date).format(
                              "YYYY-MM-DD"
                            )
                            return (
                              <>
                                <tr key={delegation._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{delegation.fromTime}</td>
                                  <td>{delegation.toTime}</td>
                                  <td>{delegation.duration}</td>
                                  <td>{delegation.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            delegation.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={delegation.attachments}>
                                        <audio controls>
                                          <source
                                            src={delegation.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(delegation.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{delegation.delegationStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleDelegationAbsent}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {nightShift && (
          <Modal show={nightShift} onHide={handleNightShift} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Night Shift</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {nightShiftDetails && nightShiftDetails.length > 0 ? (
                          nightShiftDetails.map((shift, index) => {
                            const attachment = isEmpty(shift.attachments)
                              ? "--"
                              : shift.attachments.substring(
                                  shift.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(shift.date).format("YYYY-MM-DD")
                            return (
                              <>
                                <tr key={shift._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{shift.fromTime}</td>
                                  <td>{shift.toTime}</td>
                                  <td>{shift.duration}</td>
                                  <td>{shift.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            shift.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={shift.attachments}>
                                        <audio controls>
                                          <source
                                            src={shift.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(shift.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{shift.nightShiftStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleNightShift}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {wfh && (
          <Modal show={wfh} onHide={handleWfh} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Work From Home</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {wfhDetails && wfhDetails.length > 0 ? (
                          wfhDetails.map((shift, index) => {
                            const attachment = isEmpty(shift.attachments)
                              ? "--"
                              : shift.attachments.substring(
                                  shift.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(shift.date).format("YYYY-MM-DD")
                            return (
                              <>
                                <tr key={shift._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{shift.fromTime}</td>
                                  <td>{shift.toTime}</td>
                                  <td>{shift.duration}</td>
                                  <td>{shift.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            shift.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={shift.attachments}>
                                        <audio controls>
                                          <source
                                            src={shift.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(shift.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{shift.WfhStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleWfh}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {/* //Feb Leave */}
        {febLeaveCL && (
          <Modal show={febLeaveCL} onHide={handleFebLeaveCL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave CL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {febLeaveCLDetails && febLeaveCLDetails.length > 0 ? (
                          febLeaveCLDetails.map((cl, index) => {
                            const attachment = isEmpty(cl.attachments)
                              ? ""
                              : cl.attachments.substring(
                                  cl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(cl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(cl.toDate)
                              ? moment(cl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []

                            return (
                              <>
                                <tr key={cl._id}>
                                  <td>{index + 1}</td>
                                  <td>{cl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{cl.leaveDuration}</td>
                                  <td>{cl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(cl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={cl.attachments}>
                                        <audio controls>
                                          <source
                                            src={cl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(cl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{cl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleFebLeaveCL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {febLeaveSL && (
          <Modal show={febLeaveSL} onHide={handleFebLeaveSL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave SL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {febLeaveSLDetails && febLeaveSLDetails.length > 0 ? (
                          febLeaveSLDetails.map((sl, index) => {
                            const attachment = isEmpty(sl.attachments)
                              ? ""
                              : sl.attachments.substring(
                                  sl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(sl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(sl.toDate)
                              ? moment(sl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []
                            return (
                              <>
                                <tr key={sl._id}>
                                  <td>{index + 1}</td>
                                  <td>{sl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{sl.leaveDuration}</td>
                                  <td>{sl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(sl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={sl.attachments}>
                                        <audio controls>
                                          <source
                                            src={sl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(sl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{sl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleFebLeaveSL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {febLeaveGL && (
          <Modal show={febLeaveGL} onHide={handleFebLeaveGL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave GL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {febLeaveGLDetails && febLeaveGLDetails.length > 0 ? (
                          febLeaveGLDetails.map((gl, index) => {
                            const attachment = isEmpty(gl.attachments)
                              ? "--"
                              : gl.attachments.substring(
                                  gl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(gl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(gl.toDate)
                              ? moment(gl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []
                            return (
                              <>
                                <tr key={gl._id}>
                                  <td>{index + 1}</td>
                                  <td>{gl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{gl.leaveDuration}</td>
                                  <td>{gl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(gl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={gl.attachments}>
                                        <audio controls>
                                          <source
                                            src={gl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(gl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{gl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleFebLeaveGL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {febPermissionCount && (
          <Modal
            show={febPermissionCount}
            onHide={handleFebPermissionCount}
            size="lg"
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Permission Count</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {febPermissionDetails &&
                        febPermissionDetails.length > 0 ? (
                          febPermissionDetails.map((permission, index) => {
                            const attachment = isEmpty(permission.attachments)
                              ? ""
                              : permission.attachments.substring(
                                  permission.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(permission.date).format(
                              "DD-MM-YYYY"
                            )
                            return (
                              <>
                                <tr key={permission._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{permission.fromTime}</td>
                                  <td>{permission.toTime}</td>
                                  <td>{permission.duration}</td>
                                  <td>{permission.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            permission.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={permission.attachments}>
                                        <audio controls>
                                          <source
                                            src={permission.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(permission.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{permission.permissionStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleFebPermissionCount}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {febLeaveAbsent && (
          <Modal show={febLeaveAbsent} onHide={handleFebLeaveAbsent} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Leave Absent</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "50px" }}>Date</th>
                          <th style={{ width: "50px" }}>Absent Type</th>
                          <th style={{ width: "50px" }}>Request Type</th>
                          <th style={{ width: "50px" }}>Reason</th>
                          <th style={{ width: "50px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>From Date</th>
                          <th style={{ width: "50px" }}>To Date</th>
                          <th style={{ width: "50px" }}>Start Time</th>
                          <th style={{ width: "50px" }}>End Time</th>
                          <th style={{ width: "50px" }}>Duration</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {febLeaveAbsentDetails &&
                        febLeaveAbsentDetails.length > 0 ? (
                          febLeaveAbsentDetails.map((absent, index) => {
                            const attachment = isEmpty(absent.attachments)
                              ? ""
                              : absent.attachments.substring(
                                  absent.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(absent.date).format("DD-MM-YYYY")
                            var fromDate = isEmpty(absent.fromDate)
                              ? "--"
                              : moment(absent.fromDate).format("DD-MM-YYYY")

                            var toDate = isEmpty(absent.toDate)
                              ? "--"
                              : moment(absent.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")

                            return (
                              <>
                                <tr key={absent._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{absent.absentType}</td>
                                  <td>{absent.requestTypeId}</td>
                                  <td>{absent.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            absent.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={absent.attachments}>
                                        <audio controls>
                                          <source
                                            src={absent.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(absent.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{absent.fromTime}</td>
                                  <td>{absent.toTime}</td>
                                  <td>{absent.duration}</td>
                                  <td>{absent.absentStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={14}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleFebLeaveAbsent}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {febDelegationCount && (
          <Modal
            show={febDelegationCount}
            onHide={handleFebDelegationAbsent}
            size="lg"
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Delegation Count</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {febDelegationDetails &&
                        febDelegationDetails.length > 0 ? (
                          febDelegationDetails.map((delegation, index) => {
                            const attachment = isEmpty(delegation.attachments)
                              ? "--"
                              : delegation.attachments.substring(
                                  delegation.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(delegation.date).format(
                              "YYYY-MM-DD"
                            )
                            return (
                              <>
                                <tr key={delegation._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{delegation.fromTime}</td>
                                  <td>{delegation.toTime}</td>
                                  <td>{delegation.duration}</td>
                                  <td>{delegation.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            delegation.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={delegation.attachments}>
                                        <audio controls>
                                          <source
                                            src={delegation.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(delegation.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{delegation.delegationStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleFebDelegationAbsent}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {febNightShift && (
          <Modal show={febNightShift} onHide={handleFebNightShift} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Night Shift</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {febNightShiftDetails &&
                        febNightShiftDetails.length > 0 ? (
                          febNightShiftDetails.map((shift, index) => {
                            const attachment = isEmpty(shift.attachments)
                              ? "--"
                              : shift.attachments.substring(
                                  shift.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(shift.date).format("YYYY-MM-DD")
                            return (
                              <>
                                <tr key={shift._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{shift.fromTime}</td>
                                  <td>{shift.toTime}</td>
                                  <td>{shift.duration}</td>
                                  <td>{shift.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            shift.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={shift.attachments}>
                                        <audio controls>
                                          <source
                                            src={shift.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(shift.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{shift.nightShiftStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleFebNightShift}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}

        {febWfh && (
          <Modal show={febWfh} onHide={handleFebWfh} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Work From Home</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {febWfhDetails && febWfhDetails.length > 0 ? (
                          febWfhDetails.map((shift, index) => {
                            const attachment = isEmpty(shift.attachments)
                              ? "--"
                              : shift.attachments.substring(
                                  shift.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(shift.date).format("YYYY-MM-DD")
                            return (
                              <>
                                <tr key={shift._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{shift.fromTime}</td>
                                  <td>{shift.toTime}</td>
                                  <td>{shift.duration}</td>
                                  <td>{shift.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            shift.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={shift.attachments}>
                                        <audio controls>
                                          <source
                                            src={shift.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(shift.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{shift.wfhStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleFebWfh}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {/* Mar Leave */}
        {marLeaveCL && (
          <Modal show={marLeaveCL} onHide={handleMarLeaveCL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave CL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {marLeaveCLDetails && marLeaveCLDetails.length > 0 ? (
                          marLeaveCLDetails.map((cl, index) => {
                            const attachment = isEmpty(cl.attachments)
                              ? ""
                              : cl.attachments.substring(
                                  cl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(cl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(cl.toDate)
                              ? moment(cl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []

                            return (
                              <>
                                <tr key={cl._id}>
                                  <td>{index + 1}</td>
                                  <td>{cl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{cl.leaveDuration}</td>
                                  <td>{cl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(cl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={cl.attachments}>
                                        <audio controls>
                                          <source
                                            src={cl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(cl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{cl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleMarLeaveCL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {marLeaveSL && (
          <Modal show={marLeaveSL} onHide={handleMarLeaveSL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave SL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {marLeaveSLDetails && marLeaveSLDetails.length > 0 ? (
                          marLeaveSLDetails.map((sl, index) => {
                            const attachment = isEmpty(sl.attachments)
                              ? ""
                              : sl.attachments.substring(
                                  sl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(sl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(sl.toDate)
                              ? moment(sl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []
                            return (
                              <>
                                <tr key={sl._id}>
                                  <td>{index + 1}</td>
                                  <td>{sl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{sl.leaveDuration}</td>
                                  <td>{sl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(sl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={sl.attachments}>
                                        <audio controls>
                                          <source
                                            src={sl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(sl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{sl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleMarLeaveSL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {marLeaveGL && (
          <Modal show={marLeaveGL} onHide={handleMarLeaveGL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave GL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {marLeaveGLDetails && marLeaveGLDetails.length > 0 ? (
                          marLeaveGLDetails.map((gl, index) => {
                            const attachment = isEmpty(gl.attachments)
                              ? "--"
                              : gl.attachments.substring(
                                  gl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(gl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(gl.toDate)
                              ? moment(gl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []
                            return (
                              <>
                                <tr key={gl._id}>
                                  <td>{index + 1}</td>
                                  <td>{gl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{gl.leaveDuration}</td>
                                  <td>{gl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(gl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={gl.attachments}>
                                        <audio controls>
                                          <source
                                            src={gl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(gl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{gl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleMarLeaveGL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {marPermissionCount && (
          <Modal
            show={marPermissionCount}
            onHide={handleMarPermissionCount}
            size="lg"
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Permission Count</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {marPermissionDetails &&
                        marPermissionDetails.length > 0 ? (
                          marPermissionDetails.map((permission, index) => {
                            const attachment = isEmpty(permission.attachments)
                              ? ""
                              : permission.attachments.substring(
                                  permission.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(permission.date).format(
                              "DD-MM-YYYY"
                            )
                            return (
                              <>
                                <tr key={permission._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{permission.fromTime}</td>
                                  <td>{permission.toTime}</td>
                                  <td>{permission.duration}</td>
                                  <td>{permission.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            permission.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={permission.attachments}>
                                        <audio controls>
                                          <source
                                            src={permission.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(permission.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{permission.permissionStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleMarPermissionCount}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {marLeaveAbsent && (
          <Modal show={marLeaveAbsent} onHide={handleMarLeaveAbsent} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Leave Absent</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "50px" }}>Date</th>
                          <th style={{ width: "50px" }}>Absent Type</th>
                          <th style={{ width: "50px" }}>Request Type</th>
                          <th style={{ width: "50px" }}>Reason</th>
                          <th style={{ width: "50px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>From Date</th>
                          <th style={{ width: "50px" }}>To Date</th>
                          <th style={{ width: "50px" }}>Start Time</th>
                          <th style={{ width: "50px" }}>End Time</th>
                          <th style={{ width: "50px" }}>Duration</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {marLeaveAbsentDetails &&
                        marLeaveAbsentDetails.length > 0 ? (
                          marLeaveAbsentDetails.map((absent, index) => {
                            const attachment = isEmpty(absent.attachments)
                              ? ""
                              : absent.attachments.substring(
                                  absent.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(absent.date).format("DD-MM-YYYY")
                            var fromDate = isEmpty(absent.fromDate)
                              ? "--"
                              : moment(absent.fromDate).format("DD-MM-YYYY")

                            var toDate = isEmpty(absent.toDate)
                              ? "--"
                              : moment(absent.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")

                            return (
                              <>
                                <tr key={absent._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{absent.absentType}</td>
                                  <td>{absent.requestTypeId}</td>
                                  <td>{absent.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            absent.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={absent.attachments}>
                                        <audio controls>
                                          <source
                                            src={absent.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(absent.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{absent.fromTime}</td>
                                  <td>{absent.toTime}</td>
                                  <td>{absent.duration}</td>
                                  <td>{absent.absentStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={14}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleMarLeaveAbsent}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {marDelegationCount && (
          <Modal
            show={marDelegationCount}
            onHide={handleMarDelegationAbsent}
            size="lg"
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Delegation Count</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {marDelegationDetails &&
                        marDelegationDetails.length > 0 ? (
                          marDelegationDetails.map((delegation, index) => {
                            const attachment = isEmpty(delegation.attachments)
                              ? "--"
                              : delegation.attachments.substring(
                                  delegation.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(delegation.date).format(
                              "YYYY-MM-DD"
                            )
                            return (
                              <>
                                <tr key={delegation._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{delegation.fromTime}</td>
                                  <td>{delegation.toTime}</td>
                                  <td>{delegation.duration}</td>
                                  <td>{delegation.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            delegation.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={delegation.attachments}>
                                        <audio controls>
                                          <source
                                            src={delegation.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(delegation.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{delegation.delegationStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleMarDelegationAbsent}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {marNightShift && (
          <Modal show={marNightShift} onHide={handleMarNightShift} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Night Shift</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {marNightShiftDetails &&
                        marNightShiftDetails.length > 0 ? (
                          marNightShiftDetails.map((shift, index) => {
                            const attachment = isEmpty(shift.attachments)
                              ? "--"
                              : shift.attachments.substring(
                                  shift.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(shift.date).format("YYYY-MM-DD")
                            return (
                              <>
                                <tr key={shift._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{shift.fromTime}</td>
                                  <td>{shift.toTime}</td>
                                  <td>{shift.duration}</td>
                                  <td>{shift.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            shift.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={shift.attachments}>
                                        <audio controls>
                                          <source
                                            src={shift.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(shift.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{shift.nightShiftStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleMarNightShift}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {marWfh && (
          <Modal show={marWfh} onHide={handleMarWfh} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Work From Home</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {marWfhDetails && marWfhDetails.length > 0 ? (
                          marWfhDetails.map((shift, index) => {
                            const attachment = isEmpty(shift.attachments)
                              ? "--"
                              : shift.attachments.substring(
                                  shift.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(shift.date).format("YYYY-MM-DD")
                            return (
                              <>
                                <tr key={shift._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{shift.fromTime}</td>
                                  <td>{shift.toTime}</td>
                                  <td>{shift.duration}</td>
                                  <td>{shift.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            shift.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={shift.attachments}>
                                        <audio controls>
                                          <source
                                            src={shift.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(shift.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{shift.wfhStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleMarWfh}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {/* April Leave */}
        {aprLeaveCL && (
          <Modal show={aprLeaveCL} onHide={handleAprLeaveCL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave CL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {aprLeaveCLDetails && aprLeaveCLDetails.length > 0 ? (
                          aprLeaveCLDetails.map((cl, index) => {
                            const attachment = isEmpty(cl.attachments)
                              ? ""
                              : cl.attachments.substring(
                                  cl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(cl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(cl.toDate)
                              ? moment(cl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []

                            return (
                              <>
                                <tr key={cl._id}>
                                  <td>{index + 1}</td>
                                  <td>{cl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{cl.leaveDuration}</td>
                                  <td>{cl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(cl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={cl.attachments}>
                                        <audio controls>
                                          <source
                                            src={cl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(cl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{cl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleAprLeaveCL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {aprLeaveSL && (
          <Modal show={aprLeaveSL} onHide={handleAprLeaveSL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave SL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {aprLeaveSLDetails && aprLeaveSLDetails.length > 0 ? (
                          aprLeaveSLDetails.map((sl, index) => {
                            const attachment = isEmpty(sl.attachments)
                              ? ""
                              : sl.attachments.substring(
                                  sl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(sl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(sl.toDate)
                              ? moment(sl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []
                            return (
                              <>
                                <tr key={sl._id}>
                                  <td>{index + 1}</td>
                                  <td>{sl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{sl.leaveDuration}</td>
                                  <td>{sl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(sl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={sl.attachments}>
                                        <audio controls>
                                          <source
                                            src={sl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(sl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{sl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleAprLeaveSL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {aprLeaveGL && (
          <Modal show={aprLeaveGL} onHide={handleAprLeaveGL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave GL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {aprLeaveGLDetails && aprLeaveGLDetails.length > 0 ? (
                          aprLeaveGLDetails.map((gl, index) => {
                            const attachment = isEmpty(gl.attachments)
                              ? "--"
                              : gl.attachments.substring(
                                  gl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(gl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(gl.toDate)
                              ? moment(gl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []
                            return (
                              <>
                                <tr key={gl._id}>
                                  <td>{index + 1}</td>
                                  <td>{gl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{gl.leaveDuration}</td>
                                  <td>{gl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(gl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={gl.attachments}>
                                        <audio controls>
                                          <source
                                            src={gl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(gl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{gl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleAprLeaveGL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {aprPermissionCount && (
          <Modal
            show={aprPermissionCount}
            onHide={handleAprPermissionCount}
            size="lg"
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Permission Count</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {aprPermissionDetails &&
                        aprPermissionDetails.length > 0 ? (
                          aprPermissionDetails.map((permission, index) => {
                            const attachment = isEmpty(permission.attachments)
                              ? ""
                              : permission.attachments.substring(
                                  permission.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(permission.date).format(
                              "DD-MM-YYYY"
                            )
                            return (
                              <>
                                <tr key={permission._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{permission.fromTime}</td>
                                  <td>{permission.toTime}</td>
                                  <td>{permission.duration}</td>
                                  <td>{permission.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            permission.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={permission.attachments}>
                                        <audio controls>
                                          <source
                                            src={permission.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(permission.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{permission.permissionStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleAprPermissionCount}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {aprLeaveAbsent && (
          <Modal show={aprLeaveAbsent} onHide={handleAprLeaveAbsent} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Leave Absent</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "50px" }}>Date</th>
                          <th style={{ width: "50px" }}>Absent Type</th>
                          <th style={{ width: "50px" }}>Request Type</th>
                          <th style={{ width: "50px" }}>Reason</th>
                          <th style={{ width: "50px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>From Date</th>
                          <th style={{ width: "50px" }}>To Date</th>
                          <th style={{ width: "50px" }}>Start Time</th>
                          <th style={{ width: "50px" }}>End Time</th>
                          <th style={{ width: "50px" }}>Duration</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {aprLeaveAbsentDetails &&
                        aprLeaveAbsentDetails.length > 0 ? (
                          aprLeaveAbsentDetails.map((absent, index) => {
                            const attachment = isEmpty(absent.attachments)
                              ? ""
                              : absent.attachments.substring(
                                  absent.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(absent.date).format("DD-MM-YYYY")
                            var fromDate = isEmpty(absent.fromDate)
                              ? "--"
                              : moment(absent.fromDate).format("DD-MM-YYYY")

                            var toDate = isEmpty(absent.toDate)
                              ? "--"
                              : moment(absent.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")

                            return (
                              <>
                                <tr key={absent._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{absent.absentType}</td>
                                  <td>{absent.requestTypeId}</td>
                                  <td>{absent.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            absent.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={absent.attachments}>
                                        <audio controls>
                                          <source
                                            src={absent.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(absent.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{absent.fromTime}</td>
                                  <td>{absent.toTime}</td>
                                  <td>{absent.duration}</td>
                                  <td>{absent.absentStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={14}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleAprLeaveAbsent}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {aprDelegationCount && (
          <Modal
            show={aprDelegationCount}
            onHide={handleAprDelegation}
            size="lg"
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Delegation Count</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {aprDelegationDetails &&
                        aprDelegationDetails.length > 0 ? (
                          aprDelegationDetails.map((delegation, index) => {
                            const attachment = isEmpty(delegation.attachments)
                              ? "--"
                              : delegation.attachments.substring(
                                  delegation.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(delegation.date).format(
                              "YYYY-MM-DD"
                            )
                            return (
                              <>
                                <tr key={delegation._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{delegation.fromTime}</td>
                                  <td>{delegation.toTime}</td>
                                  <td>{delegation.duration}</td>
                                  <td>{delegation.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            delegation.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={delegation.attachments}>
                                        <audio controls>
                                          <source
                                            src={delegation.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(delegation.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{delegation.delegationStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleAprDelegation}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {aprNightShift && (
          <Modal show={aprNightShift} onHide={handleAprNightShift} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Night Shift</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {aprNightShiftDetails &&
                        aprNightShiftDetails.length > 0 ? (
                          aprNightShiftDetails.map((shift, index) => {
                            const attachment = isEmpty(shift.attachments)
                              ? "--"
                              : shift.attachments.substring(
                                  shift.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(shift.date).format("YYYY-MM-DD")
                            return (
                              <>
                                <tr key={shift._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{shift.fromTime}</td>
                                  <td>{shift.toTime}</td>
                                  <td>{shift.duration}</td>
                                  <td>{shift.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            shift.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={shift.attachments}>
                                        <audio controls>
                                          <source
                                            src={shift.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(shift.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{shift.nightShiftStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleAprNightShift}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {aprWfh && (
          <Modal show={aprWfh} onHide={handleAprWfh} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Work From Home</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {aprWfhDetails && aprWfhDetails.length > 0 ? (
                          aprWfhDetails.map((shift, index) => {
                            const attachment = isEmpty(shift.attachments)
                              ? "--"
                              : shift.attachments.substring(
                                  shift.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(shift.date).format("YYYY-MM-DD")
                            return (
                              <>
                                <tr key={shift._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{shift.fromTime}</td>
                                  <td>{shift.toTime}</td>
                                  <td>{shift.duration}</td>
                                  <td>{shift.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            shift.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={shift.attachments}>
                                        <audio controls>
                                          <source
                                            src={shift.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(shift.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{shift.wfhStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleAprWfh}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {/* May Leave */}
        {mayLeaveCL && (
          <Modal show={mayLeaveCL} onHide={handleMayLeaveCL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave CL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mayLeaveCLDetails && mayLeaveCLDetails.length > 0 ? (
                          mayLeaveCLDetails.map((cl, index) => {
                            const attachment = isEmpty(cl.attachments)
                              ? ""
                              : cl.attachments.substring(
                                  cl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(cl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(cl.toDate)
                              ? moment(cl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []

                            return (
                              <>
                                <tr key={cl._id}>
                                  <td>{index + 1}</td>
                                  <td>{cl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{cl.leaveDuration}</td>
                                  <td>{cl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(cl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={cl.attachments}>
                                        <audio controls>
                                          <source
                                            src={cl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(cl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{cl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleMayLeaveCL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {mayLeaveSL && (
          <Modal show={mayLeaveSL} onHide={handleMayLeaveSL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave SL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mayLeaveSLDetails && mayLeaveSLDetails.length > 0 ? (
                          mayLeaveSLDetails.map((sl, index) => {
                            const attachment = isEmpty(sl.attachments)
                              ? ""
                              : sl.attachments.substring(
                                  sl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(sl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(sl.toDate)
                              ? moment(sl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []
                            return (
                              <>
                                <tr key={sl._id}>
                                  <td>{index + 1}</td>
                                  <td>{sl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{sl.leaveDuration}</td>
                                  <td>{sl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(sl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={sl.attachments}>
                                        <audio controls>
                                          <source
                                            src={sl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(sl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{sl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleMayLeaveSL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {mayLeaveGL && (
          <Modal show={mayLeaveGL} onHide={handleMayLeaveGL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave GL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mayLeaveGLDetails && mayLeaveGLDetails.length > 0 ? (
                          mayLeaveGLDetails.map((gl, index) => {
                            const attachment = isEmpty(gl.attachments)
                              ? "--"
                              : gl.attachments.substring(
                                  gl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(gl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(gl.toDate)
                              ? moment(gl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []
                            return (
                              <>
                                <tr key={gl._id}>
                                  <td>{index + 1}</td>
                                  <td>{gl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{gl.leaveDuration}</td>
                                  <td>{gl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(gl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={gl.attachments}>
                                        <audio controls>
                                          <source
                                            src={gl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(gl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{gl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleMayLeaveGL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {mayPermissionCount && (
          <Modal
            show={mayPermissionCount}
            onHide={handleMayPermissionCount}
            size="lg"
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Permission Count</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mayPermissionDetails &&
                        mayPermissionDetails.length > 0 ? (
                          mayPermissionDetails.map((permission, index) => {
                            const attachment = isEmpty(permission.attachments)
                              ? ""
                              : permission.attachments.substring(
                                  permission.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(permission.date).format(
                              "DD-MM-YYYY"
                            )
                            return (
                              <>
                                <tr key={permission._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{permission.fromTime}</td>
                                  <td>{permission.toTime}</td>
                                  <td>{permission.duration}</td>
                                  <td>{permission.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            permission.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={permission.attachments}>
                                        <audio controls>
                                          <source
                                            src={permission.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(permission.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{permission.permissionStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleMayPermissionCount}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {mayLeaveAbsent && (
          <Modal show={mayLeaveAbsent} onHide={handleMayLeaveAbsent} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Leave Absent</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "50px" }}>Date</th>
                          <th style={{ width: "50px" }}>Absent Type</th>
                          <th style={{ width: "50px" }}>Request Type</th>
                          <th style={{ width: "50px" }}>Reason</th>
                          <th style={{ width: "50px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>From Date</th>
                          <th style={{ width: "50px" }}>To Date</th>
                          <th style={{ width: "50px" }}>Start Time</th>
                          <th style={{ width: "50px" }}>End Time</th>
                          <th style={{ width: "50px" }}>Duration</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mayLeaveAbsentDetails &&
                        mayLeaveAbsentDetails.length > 0 ? (
                          mayLeaveAbsentDetails.map((absent, index) => {
                            const attachment = isEmpty(absent.attachments)
                              ? ""
                              : absent.attachments.substring(
                                  absent.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(absent.date).format("DD-MM-YYYY")
                            var fromDate = isEmpty(absent.fromDate)
                              ? "--"
                              : moment(absent.fromDate).format("DD-MM-YYYY")

                            var toDate = isEmpty(absent.toDate)
                              ? "--"
                              : moment(absent.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")

                            return (
                              <>
                                <tr key={absent._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{absent.absentType}</td>
                                  <td>{absent.requestTypeId}</td>
                                  <td>{absent.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            absent.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={absent.attachments}>
                                        <audio controls>
                                          <source
                                            src={absent.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(absent.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{absent.fromTime}</td>
                                  <td>{absent.toTime}</td>
                                  <td>{absent.duration}</td>
                                  <td>{absent.absentStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={14}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleMayLeaveAbsent}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {mayDelegationCount && (
          <Modal
            show={mayDelegationCount}
            onHide={handleMayDelegation}
            size="lg"
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Delegation Count</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mayDelegationDetails &&
                        mayDelegationDetails.length > 0 ? (
                          mayDelegationDetails.map((delegation, index) => {
                            const attachment = isEmpty(delegation.attachments)
                              ? "--"
                              : delegation.attachments.substring(
                                  delegation.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(delegation.date).format(
                              "YYYY-MM-DD"
                            )
                            return (
                              <>
                                <tr key={delegation._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{delegation.fromTime}</td>
                                  <td>{delegation.toTime}</td>
                                  <td>{delegation.duration}</td>
                                  <td>{delegation.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            delegation.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={delegation.attachments}>
                                        <audio controls>
                                          <source
                                            src={delegation.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(delegation.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{delegation.delegationStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleMayDelegation}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {mayNightShift && (
          <Modal show={mayNightShift} onHide={handleMayNightShift} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Night Shift</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mayNightShiftDetails &&
                        mayNightShiftDetails.length > 0 ? (
                          mayNightShiftDetails.map((shift, index) => {
                            const attachment = isEmpty(shift.attachments)
                              ? "--"
                              : shift.attachments.substring(
                                  shift.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(shift.date).format("YYYY-MM-DD")
                            return (
                              <>
                                <tr key={shift._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{shift.fromTime}</td>
                                  <td>{shift.toTime}</td>
                                  <td>{shift.duration}</td>
                                  <td>{shift.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            shift.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={shift.attachments}>
                                        <audio controls>
                                          <source
                                            src={shift.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(shift.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{shift.nightShiftStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleMayNightShift}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {mayWfh && (
          <Modal show={mayWfh} onHide={handleMayWfh} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Work From Home</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mayWfhDetails && mayWfhDetails.length > 0 ? (
                          mayWfhDetails.map((shift, index) => {
                            const attachment = isEmpty(shift.attachments)
                              ? "--"
                              : shift.attachments.substring(
                                  shift.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(shift.date).format("YYYY-MM-DD")
                            return (
                              <>
                                <tr key={shift._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{shift.fromTime}</td>
                                  <td>{shift.toTime}</td>
                                  <td>{shift.duration}</td>
                                  <td>{shift.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            shift.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={shift.attachments}>
                                        <audio controls>
                                          <source
                                            src={shift.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(shift.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{shift.wfhStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleMayWfh}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {/* June Leave */}
        {juneLeaveCL && (
          <Modal show={juneLeaveCL} onHide={handleJuneLeaveCL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave CL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {juneLeaveCLDetails && juneLeaveCLDetails.length > 0 ? (
                          juneLeaveCLDetails.map((cl, index) => {
                            const attachment = isEmpty(cl.attachments)
                              ? ""
                              : cl.attachments.substring(
                                  cl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(cl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(cl.toDate)
                              ? moment(cl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []

                            return (
                              <>
                                <tr key={cl._id}>
                                  <td>{index + 1}</td>
                                  <td>{cl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{cl.leaveDuration}</td>
                                  <td>{cl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(cl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={cl.attachments}>
                                        <audio controls>
                                          <source
                                            src={cl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(cl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{cl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleJuneLeaveCL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {juneLeaveSL && (
          <Modal show={juneLeaveSL} onHide={handleJuneLeaveSL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave SL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {juneLeaveSLDetails && juneLeaveSLDetails.length > 0 ? (
                          juneLeaveSLDetails.map((sl, index) => {
                            const attachment = isEmpty(sl.attachments)
                              ? ""
                              : sl.attachments.substring(
                                  sl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(sl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(sl.toDate)
                              ? moment(sl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []
                            return (
                              <>
                                <tr key={sl._id}>
                                  <td>{index + 1}</td>
                                  <td>{sl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{sl.leaveDuration}</td>
                                  <td>{sl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(sl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={sl.attachments}>
                                        <audio controls>
                                          <source
                                            src={sl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(sl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{sl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleJuneLeaveSL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {juneLeaveGL && (
          <Modal show={juneLeaveGL} onHide={handleJuneLeaveGL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave GL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {juneLeaveGLDetails && juneLeaveGLDetails.length > 0 ? (
                          juneLeaveGLDetails.map((gl, index) => {
                            const attachment = isEmpty(gl.attachments)
                              ? "--"
                              : gl.attachments.substring(
                                  gl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(gl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(gl.toDate)
                              ? moment(gl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []
                            return (
                              <>
                                <tr key={gl._id}>
                                  <td>{index + 1}</td>
                                  <td>{gl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{gl.leaveDuration}</td>
                                  <td>{gl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(gl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={gl.attachments}>
                                        <audio controls>
                                          <source
                                            src={gl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(gl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{gl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleJuneLeaveGL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {junePermissionCount && (
          <Modal
            show={junePermissionCount}
            onHide={handleJunePermissionCount}
            size="lg"
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Permission Count</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {junePermissionDetails &&
                        junePermissionDetails.length > 0 ? (
                          junePermissionDetails.map((permission, index) => {
                            const attachment = isEmpty(permission.attachments)
                              ? ""
                              : permission.attachments.substring(
                                  permission.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(permission.date).format(
                              "DD-MM-YYYY"
                            )
                            return (
                              <>
                                <tr key={permission._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{permission.fromTime}</td>
                                  <td>{permission.toTime}</td>
                                  <td>{permission.duration}</td>
                                  <td>{permission.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            permission.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={permission.attachments}>
                                        <audio controls>
                                          <source
                                            src={permission.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(permission.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{permission.permissionStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleJunePermissionCount}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {juneLeaveAbsent && (
          <Modal
            show={juneLeaveAbsent}
            onHide={handleJuneLeaveAbsent}
            size="lg"
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Leave Absent</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "50px" }}>Date</th>
                          <th style={{ width: "50px" }}>Absent Type</th>
                          <th style={{ width: "50px" }}>Request Type</th>
                          <th style={{ width: "50px" }}>Reason</th>
                          <th style={{ width: "50px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>From Date</th>
                          <th style={{ width: "50px" }}>To Date</th>
                          <th style={{ width: "50px" }}>Start Time</th>
                          <th style={{ width: "50px" }}>End Time</th>
                          <th style={{ width: "50px" }}>Duration</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {juneLeaveAbsentDetails &&
                        juneLeaveAbsentDetails.length > 0 ? (
                          juneLeaveAbsentDetails.map((absent, index) => {
                            const attachment = isEmpty(absent.attachments)
                              ? ""
                              : absent.attachments.substring(
                                  absent.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(absent.date).format("DD-MM-YYYY")
                            var fromDate = isEmpty(absent.fromDate)
                              ? "--"
                              : moment(absent.fromDate).format("DD-MM-YYYY")

                            var toDate = isEmpty(absent.toDate)
                              ? "--"
                              : moment(absent.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")

                            return (
                              <>
                                <tr key={absent._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{absent.absentType}</td>
                                  <td>{absent.requestTypeId}</td>
                                  <td>{absent.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            absent.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={absent.attachments}>
                                        <audio controls>
                                          <source
                                            src={absent.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(absent.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{absent.fromTime}</td>
                                  <td>{absent.toTime}</td>
                                  <td>{absent.duration}</td>
                                  <td>{absent.absentStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={14}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleJuneLeaveAbsent}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {juneDelegationCount && (
          <Modal
            show={juneDelegationCount}
            onHide={handleJuneDelegation}
            size="lg"
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Delegation Count</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {juneDelegationDetails &&
                        juneDelegationDetails.length > 0 ? (
                          juneDelegationDetails.map((delegation, index) => {
                            const attachment = isEmpty(delegation.attachments)
                              ? "--"
                              : delegation.attachments.substring(
                                  delegation.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(delegation.date).format(
                              "YYYY-MM-DD"
                            )
                            return (
                              <>
                                <tr key={delegation._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{delegation.fromTime}</td>
                                  <td>{delegation.toTime}</td>
                                  <td>{delegation.duration}</td>
                                  <td>{delegation.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            delegation.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={delegation.attachments}>
                                        <audio controls>
                                          <source
                                            src={delegation.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(delegation.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{delegation.delegationStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleJuneDelegation}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {juneNightShift && (
          <Modal show={juneNightShift} onHide={handleJuneNightShift} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Night Shift</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {juneNightShiftDetails &&
                        juneNightShiftDetails.length > 0 ? (
                          juneNightShiftDetails.map((shift, index) => {
                            const attachment = isEmpty(shift.attachments)
                              ? "--"
                              : shift.attachments.substring(
                                  shift.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(shift.date).format("YYYY-MM-DD")
                            return (
                              <>
                                <tr key={shift._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{shift.fromTime}</td>
                                  <td>{shift.toTime}</td>
                                  <td>{shift.duration}</td>
                                  <td>{shift.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            shift.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={shift.attachments}>
                                        <audio controls>
                                          <source
                                            src={shift.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(shift.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{shift.nightShiftStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleJuneNightShift}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {juneWfh && (
          <Modal show={juneWfh} onHide={handleJuneWfh} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Work From Home</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {juneWfhDetails && juneWfhDetails.length > 0 ? (
                          juneWfhDetails.map((shift, index) => {
                            const attachment = isEmpty(shift.attachments)
                              ? "--"
                              : shift.attachments.substring(
                                  shift.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(shift.date).format("YYYY-MM-DD")
                            return (
                              <>
                                <tr key={shift._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{shift.fromTime}</td>
                                  <td>{shift.toTime}</td>
                                  <td>{shift.duration}</td>
                                  <td>{shift.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            shift.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={shift.attachments}>
                                        <audio controls>
                                          <source
                                            src={shift.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(shift.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{shift.wfhStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleJuneWfh}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {/* July Leave */}
        {julyLeaveCL && (
          <Modal show={julyLeaveCL} onHide={handleJulyLeaveCL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave CL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {julyLeaveCLDetails && julyLeaveCLDetails.length > 0 ? (
                          julyLeaveCLDetails.map((cl, index) => {
                            const attachment = isEmpty(cl.attachments)
                              ? ""
                              : cl.attachments.substring(
                                  cl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(cl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(cl.toDate)
                              ? moment(cl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []

                            return (
                              <>
                                <tr key={cl._id}>
                                  <td>{index + 1}</td>
                                  <td>{cl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{cl.leaveDuration}</td>
                                  <td>{cl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(cl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={cl.attachments}>
                                        <audio controls>
                                          <source
                                            src={cl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(cl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{cl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleJulyLeaveCL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {julyLeaveSL && (
          <Modal show={julyLeaveSL} onHide={handleJulyLeaveSL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave SL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {julyLeaveSLDetails && julyLeaveSLDetails.length > 0 ? (
                          julyLeaveSLDetails.map((sl, index) => {
                            const attachment = isEmpty(sl.attachments)
                              ? ""
                              : sl.attachments.substring(
                                  sl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(sl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(sl.toDate)
                              ? moment(sl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []
                            return (
                              <>
                                <tr key={sl._id}>
                                  <td>{index + 1}</td>
                                  <td>{sl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{sl.leaveDuration}</td>
                                  <td>{sl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(sl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={sl.attachments}>
                                        <audio controls>
                                          <source
                                            src={sl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(sl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{sl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleJulyLeaveSL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {julyLeaveGL && (
          <Modal show={julyLeaveGL} onHide={handleJulyLeaveGL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave GL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {julyLeaveGLDetails && julyLeaveGLDetails.length > 0 ? (
                          julyLeaveGLDetails.map((gl, index) => {
                            const attachment = isEmpty(gl.attachments)
                              ? "--"
                              : gl.attachments.substring(
                                  gl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(gl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(gl.toDate)
                              ? moment(gl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []
                            return (
                              <>
                                <tr key={gl._id}>
                                  <td>{index + 1}</td>
                                  <td>{gl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{gl.leaveDuration}</td>
                                  <td>{gl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(gl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={gl.attachments}>
                                        <audio controls>
                                          <source
                                            src={gl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(gl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{gl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleJulyLeaveGL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {julyPermissionCount && (
          <Modal
            show={julyPermissionCount}
            onHide={handleJulyPermissionCount}
            size="lg"
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Permission Count</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {julyPermissionDetails &&
                        julyPermissionDetails.length > 0 ? (
                          julyPermissionDetails.map((permission, index) => {
                            const attachment = isEmpty(permission.attachments)
                              ? ""
                              : permission.attachments.substring(
                                  permission.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(permission.date).format(
                              "DD-MM-YYYY"
                            )
                            return (
                              <>
                                <tr key={permission._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{permission.fromTime}</td>
                                  <td>{permission.toTime}</td>
                                  <td>{permission.duration}</td>
                                  <td>{permission.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            permission.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={permission.attachments}>
                                        <audio controls>
                                          <source
                                            src={permission.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(permission.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{permission.permissionStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleJulyPermissionCount}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {julyLeaveAbsent && (
          <Modal
            show={julyLeaveAbsent}
            onHide={handleJulyLeaveAbsent}
            size="lg"
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Leave Absent</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "50px" }}>Date</th>
                          <th style={{ width: "50px" }}>Absent Type</th>
                          <th style={{ width: "50px" }}>Request Type</th>
                          <th style={{ width: "50px" }}>Reason</th>
                          <th style={{ width: "50px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>From Date</th>
                          <th style={{ width: "50px" }}>To Date</th>
                          <th style={{ width: "50px" }}>Start Time</th>
                          <th style={{ width: "50px" }}>End Time</th>
                          <th style={{ width: "50px" }}>Duration</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {julyLeaveAbsentDetails &&
                        julyLeaveAbsentDetails.length > 0 ? (
                          julyLeaveAbsentDetails.map((absent, index) => {
                            const attachment = isEmpty(absent.attachments)
                              ? ""
                              : absent.attachments.substring(
                                  absent.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(absent.date).format("DD-MM-YYYY")
                            var fromDate = isEmpty(absent.fromDate)
                              ? "--"
                              : moment(absent.fromDate).format("DD-MM-YYYY")

                            var toDate = isEmpty(absent.toDate)
                              ? "--"
                              : moment(absent.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")

                            return (
                              <>
                                <tr key={absent._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{absent.absentType}</td>
                                  <td>{absent.requestTypeId}</td>
                                  <td>{absent.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            absent.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={absent.attachments}>
                                        <audio controls>
                                          <source
                                            src={absent.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(absent.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{absent.fromTime}</td>
                                  <td>{absent.toTime}</td>
                                  <td>{absent.duration}</td>
                                  <td>{absent.absentStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={14}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleJulyLeaveAbsent}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {julyDelegationCount && (
          <Modal
            show={julyDelegationCount}
            onHide={handleJulyDelegation}
            size="lg"
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Delegation Count</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {julyDelegationDetails &&
                        julyDelegationDetails.length > 0 ? (
                          julyDelegationDetails.map((delegation, index) => {
                            const attachment = isEmpty(delegation.attachments)
                              ? "--"
                              : delegation.attachments.substring(
                                  delegation.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(delegation.date).format(
                              "YYYY-MM-DD"
                            )
                            return (
                              <>
                                <tr key={delegation._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{delegation.fromTime}</td>
                                  <td>{delegation.toTime}</td>
                                  <td>{delegation.duration}</td>
                                  <td>{delegation.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            delegation.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={delegation.attachments}>
                                        <audio controls>
                                          <source
                                            src={delegation.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(delegation.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{delegation.delegationStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleJulyDelegation}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {julyNightShift && (
          <Modal show={julyNightShift} onHide={handleJulyNightShift} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Night Shift</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {julyNightShiftDetails &&
                        julyNightShiftDetails.length > 0 ? (
                          julyNightShiftDetails.map((shift, index) => {
                            const attachment = isEmpty(shift.attachments)
                              ? "--"
                              : shift.attachments.substring(
                                  shift.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(shift.date).format("YYYY-MM-DD")
                            return (
                              <>
                                <tr key={shift._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{shift.fromTime}</td>
                                  <td>{shift.toTime}</td>
                                  <td>{shift.duration}</td>
                                  <td>{shift.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            shift.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={shift.attachments}>
                                        <audio controls>
                                          <source
                                            src={shift.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(shift.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{shift.nightShiftStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleJulyNightShift}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {julyWfh && (
          <Modal show={julyWfh} onHide={handleJulyWfh} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Work From Home</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {julyWfhDetails && julyWfhDetails.length > 0 ? (
                          julyWfhDetails.map((shift, index) => {
                            const attachment = isEmpty(shift.attachments)
                              ? "--"
                              : shift.attachments.substring(
                                  shift.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(shift.date).format("YYYY-MM-DD")
                            return (
                              <>
                                <tr key={shift._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{shift.fromTime}</td>
                                  <td>{shift.toTime}</td>
                                  <td>{shift.duration}</td>
                                  <td>{shift.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            shift.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={shift.attachments}>
                                        <audio controls>
                                          <source
                                            src={shift.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(shift.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{shift.wfhStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleJulyWfh}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {/* Aug Leave */}
        {augLeaveCL && (
          <Modal show={augLeaveCL} onHide={handleAugLeaveCL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave CL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {augLeaveCLDetails && augLeaveCLDetails.length > 0 ? (
                          augLeaveCLDetails.map((cl, index) => {
                            const attachment = isEmpty(cl.attachments)
                              ? ""
                              : cl.attachments.substring(
                                  cl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(cl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(cl.toDate)
                              ? moment(cl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []

                            return (
                              <>
                                <tr key={cl._id}>
                                  <td>{index + 1}</td>
                                  <td>{cl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{cl.leaveDuration}</td>
                                  <td>{cl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(cl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={cl.attachments}>
                                        <audio controls>
                                          <source
                                            src={cl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(cl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{cl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleAugLeaveCL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {augLeaveSL && (
          <Modal show={augLeaveSL} onHide={handleAugLeaveSL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave SL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {augLeaveSLDetails && augLeaveSLDetails.length > 0 ? (
                          augLeaveSLDetails.map((sl, index) => {
                            const attachment = isEmpty(sl.attachments)
                              ? ""
                              : sl.attachments.substring(
                                  sl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(sl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(sl.toDate)
                              ? moment(sl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []
                            return (
                              <>
                                <tr key={sl._id}>
                                  <td>{index + 1}</td>
                                  <td>{sl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{sl.leaveDuration}</td>
                                  <td>{sl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(sl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={sl.attachments}>
                                        <audio controls>
                                          <source
                                            src={sl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(sl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{sl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleAugLeaveSL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {augLeaveGL && (
          <Modal show={augLeaveGL} onHide={handleAugLeaveGL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave GL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {augLeaveGLDetails && augLeaveGLDetails.length > 0 ? (
                          augLeaveGLDetails.map((gl, index) => {
                            const attachment = isEmpty(gl.attachments)
                              ? "--"
                              : gl.attachments.substring(
                                  gl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(gl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(gl.toDate)
                              ? moment(gl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []
                            return (
                              <>
                                <tr key={gl._id}>
                                  <td>{index + 1}</td>
                                  <td>{gl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{gl.leaveDuration}</td>
                                  <td>{gl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(gl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={gl.attachments}>
                                        <audio controls>
                                          <source
                                            src={gl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(gl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{gl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleAugLeaveGL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {augPermission && (
          <Modal show={augPermission} onHide={handleAugPermission} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Permission Count</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {augPermissionDetails &&
                        augPermissionDetails.length > 0 ? (
                          augPermissionDetails.map((permission, index) => {
                            const attachment = isEmpty(permission.attachments)
                              ? ""
                              : permission.attachments.substring(
                                  permission.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(permission.date).format(
                              "DD-MM-YYYY"
                            )
                            return (
                              <>
                                <tr key={permission._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{permission.fromTime}</td>
                                  <td>{permission.toTime}</td>
                                  <td>{permission.duration}</td>
                                  <td>{permission.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            permission.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={permission.attachments}>
                                        <audio controls>
                                          <source
                                            src={permission.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(permission.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{permission.permissionStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleAugPermission}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {augLeaveAbsent && (
          <Modal show={augLeaveAbsent} onHide={handleAugLeaveAbsent} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Leave Absent</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "50px" }}>Date</th>
                          <th style={{ width: "50px" }}>Absent Type</th>
                          <th style={{ width: "50px" }}>Request Type</th>
                          <th style={{ width: "50px" }}>Reason</th>
                          <th style={{ width: "50px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>From Date</th>
                          <th style={{ width: "50px" }}>To Date</th>
                          <th style={{ width: "50px" }}>Start Time</th>
                          <th style={{ width: "50px" }}>End Time</th>
                          <th style={{ width: "50px" }}>Duration</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {augLeaveAbsentDetails &&
                        augLeaveAbsentDetails.length > 0 ? (
                          augLeaveAbsentDetails.map((absent, index) => {
                            const attachment = isEmpty(absent.attachments)
                              ? ""
                              : absent.attachments.substring(
                                  absent.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(absent.date).format("DD-MM-YYYY")
                            var fromDate = isEmpty(absent.fromDate)
                              ? "--"
                              : moment(absent.fromDate).format("DD-MM-YYYY")

                            var toDate = isEmpty(absent.toDate)
                              ? "--"
                              : moment(absent.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")

                            return (
                              <>
                                <tr key={absent._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{absent.absentType}</td>
                                  <td>{absent.requestTypeId}</td>
                                  <td>{absent.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            absent.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={absent.attachments}>
                                        <audio controls>
                                          <source
                                            src={absent.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(absent.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{absent.fromTime}</td>
                                  <td>{absent.toTime}</td>
                                  <td>{absent.duration}</td>
                                  <td>{absent.absentStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={14}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleAugLeaveAbsent}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {augDelegation && (
          <Modal show={augDelegation} onHide={handleAugDelegation} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Delegation Count</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {augDelegationDetails &&
                        augDelegationDetails.length > 0 ? (
                          augDelegationDetails.map((delegation, index) => {
                            const attachment = isEmpty(delegation.attachments)
                              ? "--"
                              : delegation.attachments.substring(
                                  delegation.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(delegation.date).format(
                              "YYYY-MM-DD"
                            )
                            return (
                              <>
                                <tr key={delegation._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{delegation.fromTime}</td>
                                  <td>{delegation.toTime}</td>
                                  <td>{delegation.duration}</td>
                                  <td>{delegation.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            delegation.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={delegation.attachments}>
                                        <audio controls>
                                          <source
                                            src={delegation.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(delegation.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{delegation.delegationStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleAugDelegation}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {augNightShift && (
          <Modal show={augNightShift} onHide={handleAugNightShift} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Night Shift</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {augNightShiftDetails &&
                        augNightShiftDetails.length > 0 ? (
                          augNightShiftDetails.map((shift, index) => {
                            const attachment = isEmpty(shift.attachments)
                              ? "--"
                              : shift.attachments.substring(
                                  shift.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(shift.date).format("YYYY-MM-DD")
                            return (
                              <>
                                <tr key={shift._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{shift.fromTime}</td>
                                  <td>{shift.toTime}</td>
                                  <td>{shift.duration}</td>
                                  <td>{shift.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            shift.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={shift.attachments}>
                                        <audio controls>
                                          <source
                                            src={shift.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(shift.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{shift.nightShiftStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleAugNightShift}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {augWfh && (
          <Modal show={augWfh} onHide={handleAugWfh} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Work From Home</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {augWfhDetails && augWfhDetails.length > 0 ? (
                          augWfhDetails.map((shift, index) => {
                            const attachment = isEmpty(shift.attachments)
                              ? "--"
                              : shift.attachments.substring(
                                  shift.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(shift.date).format("YYYY-MM-DD")
                            return (
                              <>
                                <tr key={shift._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{shift.fromTime}</td>
                                  <td>{shift.toTime}</td>
                                  <td>{shift.duration}</td>
                                  <td>{shift.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            shift.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={shift.attachments}>
                                        <audio controls>
                                          <source
                                            src={shift.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(shift.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{shift.wfhStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleAugWfh}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {/* Sep Leave */}
        {sepLeaveCL && (
          <Modal show={sepLeaveCL} onHide={handleSepLeaveCL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave CL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sepLeaveCLDetails && sepLeaveCLDetails.length > 0 ? (
                          sepLeaveCLDetails.map((cl, index) => {
                            const attachment = isEmpty(cl.attachments)
                              ? ""
                              : cl.attachments.substring(
                                  cl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(cl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(cl.toDate)
                              ? moment(cl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []

                            return (
                              <>
                                <tr key={cl._id}>
                                  <td>{index + 1}</td>
                                  <td>{cl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{cl.leaveDuration}</td>
                                  <td>{cl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(cl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={cl.attachments}>
                                        <audio controls>
                                          <source
                                            src={cl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(cl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{cl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleSepLeaveCL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {sepLeaveSL && (
          <Modal show={sepLeaveSL} onHide={handleSepLeaveSL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave SL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sepLeaveSLDetails && sepLeaveSLDetails.length > 0 ? (
                          sepLeaveSLDetails.map((sl, index) => {
                            const attachment = isEmpty(sl.attachments)
                              ? ""
                              : sl.attachments.substring(
                                  sl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(sl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(sl.toDate)
                              ? moment(sl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []
                            return (
                              <>
                                <tr key={sl._id}>
                                  <td>{index + 1}</td>
                                  <td>{sl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{sl.leaveDuration}</td>
                                  <td>{sl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(sl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={sl.attachments}>
                                        <audio controls>
                                          <source
                                            src={sl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(sl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{sl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleSepLeaveSL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {sepLeaveGL && (
          <Modal show={sepLeaveGL} onHide={handleSepLeaveGL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave GL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sepLeaveGLDetails && sepLeaveGLDetails.length > 0 ? (
                          sepLeaveGLDetails.map((gl, index) => {
                            const attachment = isEmpty(gl.attachments)
                              ? "--"
                              : gl.attachments.substring(
                                  gl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(gl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(gl.toDate)
                              ? moment(gl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []
                            return (
                              <>
                                <tr key={gl._id}>
                                  <td>{index + 1}</td>
                                  <td>{gl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{gl.leaveDuration}</td>
                                  <td>{gl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(gl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={gl.attachments}>
                                        <audio controls>
                                          <source
                                            src={gl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(gl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{gl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleSepLeaveGL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {sepPermission && (
          <Modal show={sepPermission} onHide={handleSepPermission} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Permission Count</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sepPermissionDetails &&
                        sepPermissionDetails.length > 0 ? (
                          sepPermissionDetails.map((permission, index) => {
                            const attachment = isEmpty(permission.attachments)
                              ? ""
                              : permission.attachments.substring(
                                  permission.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(permission.date).format(
                              "DD-MM-YYYY"
                            )
                            return (
                              <>
                                <tr key={permission._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{permission.fromTime}</td>
                                  <td>{permission.toTime}</td>
                                  <td>{permission.duration}</td>
                                  <td>{permission.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            permission.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={permission.attachments}>
                                        <audio controls>
                                          <source
                                            src={permission.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(permission.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{permission.permissionStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleSepPermission}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {sepLeaveAbsent && (
          <Modal show={sepLeaveAbsent} onHide={handleSepLeaveAbsent} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Leave Absent</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "50px" }}>Date</th>
                          <th style={{ width: "50px" }}>Absent Type</th>
                          <th style={{ width: "50px" }}>Request Type</th>
                          <th style={{ width: "50px" }}>Reason</th>
                          <th style={{ width: "50px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>From Date</th>
                          <th style={{ width: "50px" }}>To Date</th>
                          <th style={{ width: "50px" }}>Start Time</th>
                          <th style={{ width: "50px" }}>End Time</th>
                          <th style={{ width: "50px" }}>Duration</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sepLeaveAbsentDetails &&
                        sepLeaveAbsentDetails.length > 0 ? (
                          sepLeaveAbsentDetails.map((absent, index) => {
                            const attachment = isEmpty(absent.attachments)
                              ? ""
                              : absent.attachments.substring(
                                  absent.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(absent.date).format("DD-MM-YYYY")
                            var fromDate = isEmpty(absent.fromDate)
                              ? "--"
                              : moment(absent.fromDate).format("DD-MM-YYYY")

                            var toDate = isEmpty(absent.toDate)
                              ? "--"
                              : moment(absent.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")

                            return (
                              <>
                                <tr key={absent._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{absent.absentType}</td>
                                  <td>{absent.requestTypeId}</td>
                                  <td>{absent.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            absent.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={absent.attachments}>
                                        <audio controls>
                                          <source
                                            src={absent.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(absent.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{absent.fromTime}</td>
                                  <td>{absent.toTime}</td>
                                  <td>{absent.duration}</td>
                                  <td>{absent.absentStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={14}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleSepLeaveAbsent}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {sepDelegation && (
          <Modal show={sepDelegation} onHide={handleSepDelegation} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Delegation Count</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sepDelegationDetails &&
                        sepDelegationDetails.length > 0 ? (
                          sepDelegationDetails.map((delegation, index) => {
                            const attachment = isEmpty(delegation.attachments)
                              ? "--"
                              : delegation.attachments.substring(
                                  delegation.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(delegation.date).format(
                              "YYYY-MM-DD"
                            )
                            return (
                              <>
                                <tr key={delegation._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{delegation.fromTime}</td>
                                  <td>{delegation.toTime}</td>
                                  <td>{delegation.duration}</td>
                                  <td>{delegation.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            delegation.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={delegation.attachments}>
                                        <audio controls>
                                          <source
                                            src={delegation.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(delegation.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{delegation.delegationStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleSepDelegation}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {sepNightShift && (
          <Modal show={sepNightShift} onHide={handleSepNightShift} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Night Shift</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sepNightShiftDetails &&
                        sepNightShiftDetails.length > 0 ? (
                          sepNightShiftDetails.map((shift, index) => {
                            const attachment = isEmpty(shift.attachments)
                              ? "--"
                              : shift.attachments.substring(
                                  shift.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(shift.date).format("YYYY-MM-DD")
                            return (
                              <>
                                <tr key={shift._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{shift.fromTime}</td>
                                  <td>{shift.toTime}</td>
                                  <td>{shift.duration}</td>
                                  <td>{shift.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            shift.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={shift.attachments}>
                                        <audio controls>
                                          <source
                                            src={shift.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(shift.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{shift.nightShiftStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleSepNightShift}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {sepWfh && (
          <Modal show={sepWfh} onHide={handleSepWfh} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Work From Home</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sepWfhDetails && sepWfhDetails.length > 0 ? (
                          sepWfhDetails.map((shift, index) => {
                            const attachment = isEmpty(shift.attachments)
                              ? "--"
                              : shift.attachments.substring(
                                  shift.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(shift.date).format("YYYY-MM-DD")
                            return (
                              <>
                                <tr key={shift._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{shift.fromTime}</td>
                                  <td>{shift.toTime}</td>
                                  <td>{shift.duration}</td>
                                  <td>{shift.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            shift.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={shift.attachments}>
                                        <audio controls>
                                          <source
                                            src={shift.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(shift.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{shift.wfhStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleSepWfh}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {/* Oct Leave */}
        {octLeaveCL && (
          <Modal show={octLeaveCL} onHide={handleOctLeaveCL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave CL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {octLeaveCLDetails && octLeaveCLDetails.length > 0 ? (
                          octLeaveCLDetails.map((cl, index) => {
                            const attachment = isEmpty(cl.attachments)
                              ? ""
                              : cl.attachments.substring(
                                  cl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(cl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(cl.toDate)
                              ? moment(cl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []

                            return (
                              <>
                                <tr key={cl._id}>
                                  <td>{index + 1}</td>
                                  <td>{cl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{cl.leaveDuration}</td>
                                  <td>{cl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(cl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={cl.attachments}>
                                        <audio controls>
                                          <source
                                            src={cl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(cl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{cl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleOctLeaveCL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {octLeaveSL && (
          <Modal show={octLeaveSL} onHide={handleOctLeaveSL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave SL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {octLeaveSLDetails && octLeaveSLDetails.length > 0 ? (
                          octLeaveSLDetails.map((sl, index) => {
                            const attachment = isEmpty(sl.attachments)
                              ? ""
                              : sl.attachments.substring(
                                  sl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(sl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(sl.toDate)
                              ? moment(sl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []
                            return (
                              <>
                                <tr key={sl._id}>
                                  <td>{index + 1}</td>
                                  <td>{sl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{sl.leaveDuration}</td>
                                  <td>{sl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(sl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={sl.attachments}>
                                        <audio controls>
                                          <source
                                            src={sl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(sl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{sl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleOctLeaveSL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {octLeaveGL && (
          <Modal show={octLeaveGL} onHide={handleOctLeaveGL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave GL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {octLeaveGLDetails && octLeaveGLDetails.length > 0 ? (
                          octLeaveGLDetails.map((gl, index) => {
                            const attachment = isEmpty(gl.attachments)
                              ? "--"
                              : gl.attachments.substring(
                                  gl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(gl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(gl.toDate)
                              ? moment(gl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []
                            return (
                              <>
                                <tr key={gl._id}>
                                  <td>{index + 1}</td>
                                  <td>{gl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{gl.leaveDuration}</td>
                                  <td>{gl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(gl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={gl.attachments}>
                                        <audio controls>
                                          <source
                                            src={gl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(gl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{gl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleOctLeaveGL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {octPermission && (
          <Modal show={octPermission} onHide={handleOctPermission} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Permission Count</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {octPermissionDetails &&
                        octPermissionDetails.length > 0 ? (
                          octPermissionDetails.map((permission, index) => {
                            const attachment = isEmpty(permission.attachments)
                              ? ""
                              : permission.attachments.substring(
                                  permission.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(permission.date).format(
                              "DD-MM-YYYY"
                            )
                            return (
                              <>
                                <tr key={permission._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{permission.fromTime}</td>
                                  <td>{permission.toTime}</td>
                                  <td>{permission.duration}</td>
                                  <td>{permission.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            permission.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={permission.attachments}>
                                        <audio controls>
                                          <source
                                            src={permission.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(permission.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{permission.permissionStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleOctPermission}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {octLeaveAbsent && (
          <Modal show={octLeaveAbsent} onHide={handleOctLeaveAbsent} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Leave Absent</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "50px" }}>Date</th>
                          <th style={{ width: "50px" }}>Absent Type</th>
                          <th style={{ width: "50px" }}>Request Type</th>
                          <th style={{ width: "50px" }}>Reason</th>
                          <th style={{ width: "50px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>From Date</th>
                          <th style={{ width: "50px" }}>To Date</th>
                          <th style={{ width: "50px" }}>Start Time</th>
                          <th style={{ width: "50px" }}>End Time</th>
                          <th style={{ width: "50px" }}>Duration</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {octLeaveAbsentDetails &&
                        octLeaveAbsentDetails.length > 0 ? (
                          octLeaveAbsentDetails.map((absent, index) => {
                            const attachment = isEmpty(absent.attachments)
                              ? ""
                              : absent.attachments.substring(
                                  absent.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(absent.date).format("DD-MM-YYYY")
                            var fromDate = isEmpty(absent.fromDate)
                              ? "--"
                              : moment(absent.fromDate).format("DD-MM-YYYY")

                            var toDate = isEmpty(absent.toDate)
                              ? "--"
                              : moment(absent.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")

                            return (
                              <>
                                <tr key={absent._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{absent.absentType}</td>
                                  <td>{absent.requestTypeId}</td>
                                  <td>{absent.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            absent.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={absent.attachments}>
                                        <audio controls>
                                          <source
                                            src={absent.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(absent.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{absent.fromTime}</td>
                                  <td>{absent.toTime}</td>
                                  <td>{absent.duration}</td>
                                  <td>{absent.absentStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={14}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleOctLeaveAbsent}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {octDelegation && (
          <Modal show={octDelegation} onHide={handleOctDelegation} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Delegation Count</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {octDelegationDetails &&
                        octDelegationDetails.length > 0 ? (
                          octDelegationDetails.map((delegation, index) => {
                            const attachment = isEmpty(delegation.attachments)
                              ? "--"
                              : delegation.attachments.substring(
                                  delegation.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(delegation.date).format(
                              "YYYY-MM-DD"
                            )
                            return (
                              <>
                                <tr key={delegation._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{delegation.fromTime}</td>
                                  <td>{delegation.toTime}</td>
                                  <td>{delegation.duration}</td>
                                  <td>{delegation.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            delegation.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={delegation.attachments}>
                                        <audio controls>
                                          <source
                                            src={delegation.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(delegation.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{delegation.delegationStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleOctDelegation}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {octNightShift && (
          <Modal show={octNightShift} onHide={handleOctNightShift} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Night Shift</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {octNightShiftDetails &&
                        octNightShiftDetails.length > 0 ? (
                          octNightShiftDetails.map((shift, index) => {
                            const attachment = isEmpty(shift.attachments)
                              ? "--"
                              : shift.attachments.substring(
                                  shift.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(shift.date).format("YYYY-MM-DD")
                            return (
                              <>
                                <tr key={shift._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{shift.fromTime}</td>
                                  <td>{shift.toTime}</td>
                                  <td>{shift.duration}</td>
                                  <td>{shift.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            shift.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={shift.attachments}>
                                        <audio controls>
                                          <source
                                            src={shift.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(shift.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{shift.nightShiftStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleOctNightShift}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {octWfh && (
          <Modal show={octWfh} onHide={handleOctWfh} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Work From Home</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {octWfhDetails && octWfhDetails.length > 0 ? (
                          octWfhDetails.map((shift, index) => {
                            const attachment = isEmpty(shift.attachments)
                              ? "--"
                              : shift.attachments.substring(
                                  shift.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(shift.date).format("YYYY-MM-DD")
                            return (
                              <>
                                <tr key={shift._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{shift.fromTime}</td>
                                  <td>{shift.toTime}</td>
                                  <td>{shift.duration}</td>
                                  <td>{shift.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            shift.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={shift.attachments}>
                                        <audio controls>
                                          <source
                                            src={shift.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(shift.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{shift.wfhStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleOctWfh}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {/* Nov Leave */}
        {novLeaveCL && (
          <Modal show={novLeaveCL} onHide={handleNovLeaveCL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave CL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {novLeaveCLDetails && novLeaveCLDetails.length > 0 ? (
                          novLeaveCLDetails.map((cl, index) => {
                            const attachment = isEmpty(cl.attachments)
                              ? ""
                              : cl.attachments.substring(
                                  cl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(cl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(cl.toDate)
                              ? moment(cl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []

                            return (
                              <>
                                <tr key={cl._id}>
                                  <td>{index + 1}</td>
                                  <td>{cl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{cl.leaveDuration}</td>
                                  <td>{cl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(cl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={cl.attachments}>
                                        <audio controls>
                                          <source
                                            src={cl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(cl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{cl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleNovLeaveCL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {novLeaveSL && (
          <Modal show={novLeaveSL} onHide={handleNovLeaveSL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave SL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {novLeaveSLDetails && novLeaveSLDetails.length > 0 ? (
                          novLeaveSLDetails.map((sl, index) => {
                            const attachment = isEmpty(sl.attachments)
                              ? ""
                              : sl.attachments.substring(
                                  sl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(sl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(sl.toDate)
                              ? moment(sl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []
                            return (
                              <>
                                <tr key={sl._id}>
                                  <td>{index + 1}</td>
                                  <td>{sl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{sl.leaveDuration}</td>
                                  <td>{sl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(sl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={sl.attachments}>
                                        <audio controls>
                                          <source
                                            src={sl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(sl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{sl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleNovLeaveSL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {novLeaveGL && (
          <Modal show={novLeaveGL} onHide={handleNovLeaveGL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave GL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {novLeaveGLDetails && novLeaveGLDetails.length > 0 ? (
                          novLeaveGLDetails.map((gl, index) => {
                            const attachment = isEmpty(gl.attachments)
                              ? "--"
                              : gl.attachments.substring(
                                  gl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(gl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(gl.toDate)
                              ? moment(gl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []
                            return (
                              <>
                                <tr key={gl._id}>
                                  <td>{index + 1}</td>
                                  <td>{gl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{gl.leaveDuration}</td>
                                  <td>{gl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(gl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={gl.attachments}>
                                        <audio controls>
                                          <source
                                            src={gl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(gl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{gl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleNovLeaveGL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {novPermission && (
          <Modal show={novPermission} onHide={handleNovPermission} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Permission Count</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {novPermissionDetails &&
                        novPermissionDetails.length > 0 ? (
                          novPermissionDetails.map((permission, index) => {
                            const attachment = isEmpty(permission.attachments)
                              ? ""
                              : permission.attachments.substring(
                                  permission.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(permission.date).format(
                              "DD-MM-YYYY"
                            )
                            return (
                              <>
                                <tr key={permission._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{permission.fromTime}</td>
                                  <td>{permission.toTime}</td>
                                  <td>{permission.duration}</td>
                                  <td>{permission.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            permission.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={permission.attachments}>
                                        <audio controls>
                                          <source
                                            src={permission.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(permission.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{permission.permissionStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleNovPermission}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {novLeaveAbsent && (
          <Modal show={novLeaveAbsent} onHide={handleNovLeaveAbsent} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Leave Absent</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "50px" }}>Date</th>
                          <th style={{ width: "50px" }}>Absent Type</th>
                          <th style={{ width: "50px" }}>Request Type</th>
                          <th style={{ width: "50px" }}>Reason</th>
                          <th style={{ width: "50px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>From Date</th>
                          <th style={{ width: "50px" }}>To Date</th>
                          <th style={{ width: "50px" }}>Start Time</th>
                          <th style={{ width: "50px" }}>End Time</th>
                          <th style={{ width: "50px" }}>Duration</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {novLeaveAbsentDetails &&
                        novLeaveAbsentDetails.length > 0 ? (
                          novLeaveAbsentDetails.map((absent, index) => {
                            const attachment = isEmpty(absent.attachments)
                              ? ""
                              : absent.attachments.substring(
                                  absent.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(absent.date).format("DD-MM-YYYY")
                            var fromDate = isEmpty(absent.fromDate)
                              ? "--"
                              : moment(absent.fromDate).format("DD-MM-YYYY")

                            var toDate = isEmpty(absent.toDate)
                              ? "--"
                              : moment(absent.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")

                            return (
                              <>
                                <tr key={absent._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{absent.absentType}</td>
                                  <td>{absent.requestTypeId}</td>
                                  <td>{absent.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            absent.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={absent.attachments}>
                                        <audio controls>
                                          <source
                                            src={absent.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(absent.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{absent.fromTime}</td>
                                  <td>{absent.toTime}</td>
                                  <td>{absent.duration}</td>
                                  <td>{absent.absentStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={14}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleNovLeaveAbsent}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {novDelegation && (
          <Modal show={novDelegation} onHide={handleNovDelegation} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Delegation Count</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {novDelegationDetails &&
                        novDelegationDetails.length > 0 ? (
                          novDelegationDetails.map((delegation, index) => {
                            const attachment = isEmpty(delegation.attachments)
                              ? "--"
                              : delegation.attachments.substring(
                                  delegation.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(delegation.date).format(
                              "YYYY-MM-DD"
                            )
                            return (
                              <>
                                <tr key={delegation._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{delegation.fromTime}</td>
                                  <td>{delegation.toTime}</td>
                                  <td>{delegation.duration}</td>
                                  <td>{delegation.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            delegation.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={delegation.attachments}>
                                        <audio controls>
                                          <source
                                            src={delegation.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(delegation.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{delegation.delegationStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleNovDelegation}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {novNightShift && (
          <Modal show={novNightShift} onHide={handleNovNightShift} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Night Shift</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {novNightShiftDetails &&
                        novNightShiftDetails.length > 0 ? (
                          novNightShiftDetails.map((shift, index) => {
                            const attachment = isEmpty(shift.attachments)
                              ? "--"
                              : shift.attachments.substring(
                                  shift.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(shift.date).format("YYYY-MM-DD")
                            return (
                              <>
                                <tr key={shift._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{shift.fromTime}</td>
                                  <td>{shift.toTime}</td>
                                  <td>{shift.duration}</td>
                                  <td>{shift.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            shift.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={shift.attachments}>
                                        <audio controls>
                                          <source
                                            src={shift.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(shift.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{shift.nightShiftStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleNovNightShift}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {novWfh && (
          <Modal show={novWfh} onHide={handleNovWfh} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Work From Home</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {novWfhDetails && novWfhDetails.length > 0 ? (
                          novWfhDetails.map((shift, index) => {
                            const attachment = isEmpty(shift.attachments)
                              ? "--"
                              : shift.attachments.substring(
                                  shift.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(shift.date).format("YYYY-MM-DD")
                            return (
                              <>
                                <tr key={shift._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{shift.fromTime}</td>
                                  <td>{shift.toTime}</td>
                                  <td>{shift.duration}</td>
                                  <td>{shift.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            shift.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={shift.attachments}>
                                        <audio controls>
                                          <source
                                            src={shift.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(shift.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{shift.wfhStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleNovWfh}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {/* Dec Leave */}
        {decLeaveCL && (
          <Modal show={decLeaveCL} onHide={handleDecLeaveCL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave CL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {decLeaveCLDetails && decLeaveCLDetails.length > 0 ? (
                          decLeaveCLDetails.map((cl, index) => {
                            const attachment = isEmpty(cl.attachments)
                              ? ""
                              : cl.attachments.substring(
                                  cl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(cl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(cl.toDate)
                              ? moment(cl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []

                            return (
                              <>
                                <tr key={cl._id}>
                                  <td>{index + 1}</td>
                                  <td>{cl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{cl.leaveDuration}</td>
                                  <td>{cl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(cl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={cl.attachments}>
                                        <audio controls>
                                          <source
                                            src={cl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(cl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{cl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleDecLeaveCL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {decLeaveSL && (
          <Modal show={decLeaveSL} onHide={handleDecLeaveSL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave SL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {decLeaveSLDetails && decLeaveSLDetails.length > 0 ? (
                          decLeaveSLDetails.map((sl, index) => {
                            const attachment = isEmpty(sl.attachments)
                              ? ""
                              : sl.attachments.substring(
                                  sl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(sl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(sl.toDate)
                              ? moment(sl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []
                            return (
                              <>
                                <tr key={sl._id}>
                                  <td>{index + 1}</td>
                                  <td>{sl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{sl.leaveDuration}</td>
                                  <td>{sl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(sl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={sl.attachments}>
                                        <audio controls>
                                          <source
                                            src={sl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(sl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{sl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleDecLeaveSL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {decLeaveGL && (
          <Modal show={decLeaveGL} onHide={handleDecLeaveGL} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>January Leave GL</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "20px" }}>Request No</th>
                          <th style={{ width: "70px" }}>From Date</th>
                          <th style={{ width: "70px" }}>To Date</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {decLeaveGLDetails && decLeaveGLDetails.length > 0 ? (
                          decLeaveGLDetails.map((gl, index) => {
                            const attachment = isEmpty(gl.attachments)
                              ? "--"
                              : gl.attachments.substring(
                                  gl.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var fromDate = moment(gl.fromDate).format(
                              "DD-MM-YYYY"
                            )
                            var toDate = !isEmpty(gl.toDate)
                              ? moment(gl.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")
                              : []
                            return (
                              <>
                                <tr key={gl._id}>
                                  <td>{index + 1}</td>
                                  <td>{gl.requestNo}</td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{gl.leaveDuration}</td>
                                  <td>{gl.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(gl.attachments, "_blank")
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={gl.attachments}>
                                        <audio controls>
                                          <source
                                            src={gl.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(gl.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{gl.leaveStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleDecLeaveGL}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {decPermission && (
          <Modal show={decPermission} onHide={handleDecPermission} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Permission Count</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {decPermissionDetails &&
                        decPermissionDetails.length > 0 ? (
                          decPermissionDetails.map((permission, index) => {
                            const attachment = isEmpty(permission.attachments)
                              ? ""
                              : permission.attachments.substring(
                                  permission.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(permission.date).format(
                              "DD-MM-YYYY"
                            )
                            return (
                              <>
                                <tr key={permission._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{permission.fromTime}</td>
                                  <td>{permission.toTime}</td>
                                  <td>{permission.duration}</td>
                                  <td>{permission.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            permission.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={permission.attachments}>
                                        <audio controls>
                                          <source
                                            src={permission.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(permission.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{permission.permissionStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleDecPermission}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {decLeaveAbsent && (
          <Modal show={decLeaveAbsent} onHide={handleDecLeaveAbsent} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Leave Absent</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "50px" }}>Date</th>
                          <th style={{ width: "50px" }}>Absent Type</th>
                          <th style={{ width: "50px" }}>Request Type</th>
                          <th style={{ width: "50px" }}>Reason</th>
                          <th style={{ width: "50px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>From Date</th>
                          <th style={{ width: "50px" }}>To Date</th>
                          <th style={{ width: "50px" }}>Start Time</th>
                          <th style={{ width: "50px" }}>End Time</th>
                          <th style={{ width: "50px" }}>Duration</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {decLeaveAbsentDetails &&
                        decLeaveAbsentDetails.length > 0 ? (
                          decLeaveAbsentDetails.map((absent, index) => {
                            const attachment = isEmpty(absent.attachments)
                              ? ""
                              : absent.attachments.substring(
                                  absent.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(absent.date).format("DD-MM-YYYY")
                            var fromDate = isEmpty(absent.fromDate)
                              ? "--"
                              : moment(absent.fromDate).format("DD-MM-YYYY")

                            var toDate = isEmpty(absent.toDate)
                              ? "--"
                              : moment(absent.toDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format("DD-MM-YYYY")

                            return (
                              <>
                                <tr key={absent._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{absent.absentType}</td>
                                  <td>{absent.requestTypeId}</td>
                                  <td>{absent.reason}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            absent.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={absent.attachments}>
                                        <audio controls>
                                          <source
                                            src={absent.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(absent.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{fromDate}</td>
                                  <td>{toDate}</td>
                                  <td>{absent.fromTime}</td>
                                  <td>{absent.toTime}</td>
                                  <td>{absent.duration}</td>
                                  <td>{absent.absentStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={14}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleDecLeaveAbsent}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {decDelegation && (
          <Modal show={decDelegation} onHide={handleDecDelegation} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Delegation Count</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {decDelegationDetails &&
                        decDelegationDetails.length > 0 ? (
                          decDelegationDetails.map((delegation, index) => {
                            const attachment = isEmpty(delegation.attachments)
                              ? "--"
                              : delegation.attachments.substring(
                                  delegation.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(delegation.date).format(
                              "YYYY-MM-DD"
                            )
                            return (
                              <>
                                <tr key={delegation._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{delegation.fromTime}</td>
                                  <td>{delegation.toTime}</td>
                                  <td>{delegation.duration}</td>
                                  <td>{delegation.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            delegation.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={delegation.attachments}>
                                        <audio controls>
                                          <source
                                            src={delegation.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(delegation.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{delegation.delegationStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleDecDelegation}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {decNightShift && (
          <Modal show={decNightShift} onHide={handleDecNightShift} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Night Shift</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {decNightShiftDetails &&
                        decNightShiftDetails.length > 0 ? (
                          decNightShiftDetails.map((shift, index) => {
                            const attachment = isEmpty(shift.attachments)
                              ? "--"
                              : shift.attachments.substring(
                                  shift.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(shift.date).format("YYYY-MM-DD")
                            return (
                              <>
                                <tr key={shift._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{shift.fromTime}</td>
                                  <td>{shift.toTime}</td>
                                  <td>{shift.duration}</td>
                                  <td>{shift.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            shift.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={shift.attachments}>
                                        <audio controls>
                                          <source
                                            src={shift.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(shift.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{shift.nightShiftStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleDecNightShift}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {decWfh && (
          <Modal show={decWfh} onHide={handleDecWfh} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Work From Home</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ width: "20px" }}>S.No</th>
                          <th style={{ width: "70px" }}>Date</th>
                          <th style={{ width: "70px" }}>Start Time</th>
                          <th style={{ width: "70px" }}>End Time</th>
                          <th style={{ width: "70px" }}>Duration</th>
                          <th style={{ width: "70px" }}>Reason</th>
                          <th style={{ width: "70px" }}>Attachment</th>
                          <th style={{ width: "50px" }}>Status</th>
                          <th style={{ width: "70px" }}>Approved On</th>
                          <th style={{ width: "70px" }}>Approved By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {decWfhDetails && decWfhDetails.length > 0 ? (
                          decWfhDetails.map((shift, index) => {
                            const attachment = isEmpty(shift.attachments)
                              ? "--"
                              : shift.attachments.substring(
                                  shift.attachments.lastIndexOf(".") + 1
                                )

                            // console.log(attachment, "attachment")
                            var date = moment(shift.date).format("YYYY-MM-DD")
                            return (
                              <>
                                <tr key={shift._id}>
                                  <td>{index + 1}</td>
                                  <td>{date}</td>
                                  <td>{shift.fromTime}</td>
                                  <td>{shift.toTime}</td>
                                  <td>{shift.duration}</td>
                                  <td>{shift.purpose}</td>
                                  <td>
                                    {attachment === "jpeg" ||
                                    attachment === "jpg" ||
                                    attachment === "png" ? (
                                      <a
                                        onClick={() =>
                                          window.open(
                                            shift.attachments,
                                            "_blank"
                                          )
                                        }
                                      >
                                        <span
                                          style={{
                                            textDecoration: "underline",
                                            color: "#E40D8C",
                                          }}
                                        >
                                          View
                                        </span>
                                      </a>
                                    ) : attachment === "mp3" ||
                                      attachment === "m4a" ||
                                      attachment === "mp4" ? (
                                      <a href={shift.attachments}>
                                        <audio controls>
                                          <source
                                            src={shift.attachments}
                                            type="audio/mpeg"
                                          />
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </a>
                                    ) : isEmpty(shift.attachments) ? (
                                      "--"
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                  <td>{shift.wfhStatus}</td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={10}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleDecWfh}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}

        {btnLoading ? (
          <Modal show={btnLoading} style={{ width: "7%", margin: "18% 50%" }}>
            <Modal.Body>
              <Spinner
                as="span"
                animation="grow"
                size="lg"
                role="status"
                aria-hidden="true"
                variant="success"
                className="mx-2"
                color="success"
              />
            </Modal.Body>
          </Modal>
        ) : (
          ""
        )}
        {loading ? (
          <Modal show={loading} style={{ width: "7%", margin: "18% 50%" }}>
            <Modal.Body>
              <Spinner
                as="span"
                animation="grow"
                size="lg"
                role="status"
                aria-hidden="true"
                variant="success"
                className="mx-2"
                color="success"
              />
              {/* <span>Loading...</span> */}
            </Modal.Body>
          </Modal>
        ) : (
          ""
        )}
        {downloadLoading ? (
          <Modal
            show={downloadLoading}
            style={{ width: "7%", margin: "18% 50%" }}
          >
            <Modal.Body>
              <Spinner
                as="span"
                animation="grow"
                size="lg"
                role="status"
                aria-hidden="true"
                variant="success"
                className="mx-2"
                color="success"
              />
              {/* <span>Loading...</span> */}
            </Modal.Body>
          </Modal>
        ) : (
          ""
        )}
      </div>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </React.Fragment>
  )
}
YearWiseEmployeeRecord.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.array,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  csvProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
  columns: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(YearWiseEmployeeRecord)
)
